import { map } from 'lodash';

export const arIL = {
    confirm: 'تأكيد',
    common: {
        replace: 'استبدال',
        remove: 'إزالة',
        optional: 'اختياري',
    },
    login: {
        identifier: 'مُعرّف',
        password: 'كلمة المرور',
        login: 'تسجيل الدخول',
        verificationCodeFromSMS: 'رمز التحقق الذي استلمته عبر الرسالة النصية',
        messageWasSentToSMS: (key, { last4digits }) =>
            `تم إرسال رسالة نصية قصيرة (SMS) إلى رقم الهاتف الذي ينتهي بـ ${last4digits}`,
        messageWasSentToEMAIL: (key, {maskedEmail}) => `تم إرسال رسالة إلى ${maskedEmail}`,
        validate: 'تحقق',
        resendCode: 'إعادة إرسال الرمز',
        sendCode: 'إرسال رمز التحقق',
        helloX: (key, { name }) => `مرحبًا ${name}`,
        sendBySMS: 'SMS',
        sendByEmail: 'البريد الإلكتروني',
        sendByWhatsApp: 'واتساب',
        messageWasSentToWhatsApp: (key, { last4digits }) => `تم إرسال رسالة واتساب إلى رقم الهاتف الذي ينتهي بـ ${last4digits}`,
    },
    otpLogin: {
        sendToEmail: 'البريد الإلكتروني',
        sendToPhone: 'SMS',
        sendToWhatsApp: 'واتساب',
        emailAddress: 'عنوان البريد الإلكتروني',
        phoneNumber: 'رقم الهاتف',
        phonePlaceholder: 'أدخل رقم الهاتف',
        invalidPhoneNumber: 'رقم هاتف غير صالح',
        sendVerificationCode: 'إرسال رمز التحقق',
        title: 'تسجيل الدخول برمز التحقق',
        selectCompany: 'اختر الشركة',
        selectCompanySubtitle: 'أنت مسجل في عدة شركات. يرجى اختيار الشركة التي تريد تسجيل الدخول إليها:',
        backToContactInfo: 'العودة إلى معلومات الاتصال',
    },
    changePassword: {
        currentPassword: 'كلمة المرور الحالية',
        password: 'كلمة المرور الجديدة',
        repeatPassword: 'إعادة إدخال كلمة المرور الجديدة',
        changePassword: 'تغيير كلمة المرور',
        weakPassword: 'كلمة المرور ضعيفة جدًا، يجب أن تحتوي كلمة المرور على حرف كبير واحد على الأقل ورقم واحد وأن تكون بطول 8 أحرف على الأقل',
        newPasswordsDoesNotMatch: 'كلمات المرور غير متطابقة',
        pleaseFillAllFields: 'يرجى ملء جميع الحقول المطلوبة'
    },
    logout: 'تسجيل الخروج',
    menuItems: {
        logout: 'تسجيل الخروج',
        changePassword: 'تغيير كلمة المرور',
        adminPanel: 'لوحة الإدارة',
        home: 'الصفحة الرئيسية',
        myOrgs: 'الوحدات التنظيمية الخاصة بي',
        learningCenter: 'مركز التعلم',
        users: 'المستخدمون',
        reports: 'التقارير',
        settings: 'الإعدادات',
        learningManagement: 'إدارة التعلم',
        filesManagement: 'إدارة الملفات',
        knowledgeCenter: 'مركز المعرفة',
        operation: 'التشغيل',
        superAdmin: {
            courses: 'إدارة الدورات',
            customers: 'إدارة العملاء',
            organizations: 'إدارة الوحدات التنظيمية',
            users: 'إدارة المستخدمين',
            dashboards: 'التقارير',
            partners: 'إدارة الشركاء',
            assets: 'إدارة الأصول',
            courseTemplates: 'قوالب الدورات'
        },
    },
    languages: {
        label: 'اختر اللغة',
        languageKeys: {
            heIL: 'עברית',
            enUS: 'English',
            arIL: 'العربية',
            ruRU: 'Русский',
            ptPT: 'Português'
        }
    },
    n8nChat: {
        title: 'Buzz AI',
        subtitle: 'وكيل الذكاء الاصطناعي الخاص بك من WeezBee',
        greeting: 'مرحبًا، أنا Buzz AI - وكيل الذكاء الاصطناعي الخاص بك من WeezBee. كيف يمكنني مساعدتك؟',
        newConversation: 'محادثة جديدة',
        inputPlaceholder: 'أرسل رسالة هنا...',
        closeChat: 'إغلاق الدردشة'
    },
    learningCenter: {
        title: 'مركز التعلم الخاص بي',
        subTitle: 'المهام وحالة إكمالها',
        coursesToDo: 'دورات لم تُستكمل بعد',
        coursesCompleted: 'الدورات التي أكملتها',
        noCoursesToDo: 'لا توجد دورات غير مكتملة',
        noCoursesCompleted: 'لا توجد دورات مكتملة',
        signDocsToDo: 'مستندات للتوقيع',
        noSignDocsToDo: 'لا توجد مستندات للتوقيع',
        noSignDocsCompleted: 'لا توجد مستندات قمت بتوقيعها',
        signDocsCompleted: 'المستندات التي وقّعت عليها',
        noOpenTasks: 'لا توجد مهام مفتوحة',

        // Archived SignDocs
        archivedSignDocs: 'المهام المؤرشفة',
        noArchivedSignDocs: 'لا توجد مهام مؤرشفة',
        versionsCount: (key, { count }) => `${count} إصدارات`,
        versions: 'إصدارات',
        archivedVersions: 'الإصدارات المؤرشفة',
        versionsNotFound: 'لم يتم العثور على الإصدارات',
        versionsNotFoundDescription: 'لم يتم العثور على إصدارات مؤرشفة لهذه المهمة',

        // UPLOAD_DOCUMENT
        uploadsToDo: 'مستندات لم تُعتمد بعد',
        uploadsCompleted: 'مستندات معتمدة',
        noUploadsToDo: 'لا توجد مستندات للتحميل',
        noUploadsCompleted: 'لا توجد مستندات قمت بتحميلها',

        tabs: {
            myCourses: 'دوراتي',
            courses: 'تدريبات مباشرة وعبر الإنترنت',
            mySignDocs: 'مستندات للتوقيع',
            myTasks: 'مهام مفتوحة',
            myCertifications: 'الشهادات',
            myExams: 'الامتحانات',
            myWeezbeeCourses: 'الدورات',
            learningPaths: 'مسارات التعلم',
            myVideos: 'مقاطع الفيديو',
            myAudioFiles: 'ملفات الصوت',
            myLinks: 'الروابط',
            surveys: 'الاستطلاعات',
            myPresentations: 'العروض التقديمية',
            uploads: 'تحميلات المستندات',
            myContent: 'محتوياتي',
            archived: 'الأرشيف',
        },
        searchMyContent: 'البحث في المحتوى',
        searchMyContentPlaceholder: 'البحث بالاسم...',
        filterByType: 'تصفية حسب النوع',
    },
    settingsPage: {
        title: 'الإعدادات',
        subTitle: 'اضبط النظام',
        subTitleBold: 'وفق احتياجات شركتك',
        buttons: {
            updateLogo: 'تحديث الشعار',
            updateOrgName: 'تحديث أسماء الوحدات التنظيمية',
            addOrg: "إضافة وحدات تنظيمية",
            updateNotes: 'تحديث الملاحظات للموظفين',
            adminInstructionCourse: "دورة إرشادية للإداريين",
        },
        editNotesModal: {
            title: 'تحرير الملاحظات للموظفين',
        },
        addOrganizationModal: {
            organizationsList: 'قائمة الوحدات التنظيمية',
            useCommaSeparatedValues:
                'أدخل قيمًا مفصولة بفواصل، مثال: "المالية, المحاسبة, تطوير البرمجيات"',
            title: 'إضافة وحدات تنظيمية',
        },
        editOrganizationsNames: 'تحرير أسماء الوحدات التنظيمية',
        createNote: 'إنشاء ملاحظة جديدة',
        newNoteTitle: 'ملاحظة جديدة',
        SMSQuota: {
            title: 'رصيد الرسائل',
            quota: 'الرسائل المشتراة',
            sent: (key, { sent, quota }) =>
                `للعلم، حتى الآن تم إرسال ${sent} رسالة وبقي لديك ${quota} رسالة للاستخدام مستقبلًا`,
            lastSMSWasSentOn: (key, { date }) =>
                `آخر الرسائل تم إرسالها من النظام بتاريخ ${date}`,
        },
        generalSettings: {
            title: 'عام',
        },
        reminders: {
            title: 'التذكيرات',
            course: 'دورة',
            signDoc: 'مستند للتوقيع',
            watchVideo: 'مشاهدة فيديو',
            listenAudio: 'استماع إلى ملف صوتي',
            canvaPresentation: 'عرض Canva',
            exam: 'امتحان',
            learningPath: 'مسار التعلم',
            link: 'رابط',
            survey: 'استطلاع',
            weezbeeCourse: 'دورة عبر الإنترنت',
            frontalCourse: 'محاضرة حضورية',
            onlineCourse: 'دورة عبر الإنترنت',
            uploadDocument: 'تحميل مستند',
        },
        admins: {
            title: 'المديرون',
            subTitle: 'الإدارة والإعدادات',
        },
        setup: {
            title: 'إعدادات الإنشاء'
        },
        deletedUsers: {
            title: 'المستخدمين المحذوفين'
        },
        organizationalUnits: {
            title: 'الوحدات التنظيمية',
        }
    },
    HomePage: {
        courseLegend: {
            completed: 'انتهيت',
            inProgress: 'قيد التقدم',
            notStarted: 'لم أبدأ',
        },
    },
    home: {
        title: 'الدورات المتاحة لك',
        faq: 'الأسئلة الشائعة',
        welcome: 'أهلاً وسهلاً',
        learningSubtitle: 'إلى بيئة التعلم الشخصية، لشركة',
        userChartLabels: {
            finishedCourses: 'الدورات التي أكملتها',
            inProgressCourses: 'الدورات قيد التقدم',
            notStartedCourses: 'دورات لم تبدأ بعد',
            label: 'التقدم في الدورات',
        },
        superAdmin: 'واجهة مدير النظام',
    },
    faq: {
        question1: 'هل يمكنني العودة إلى الدورات في أي وقت؟',
        answer1:
            'نعم. يمكنك التعلم بوتيرتك الخاصة من أي مكان وفي أي وقت، من هاتفك المحمول أو حاسوبك (نوصي باستخدام متصفح جوجل كروم). انتبه أنه بمجرد بدء الدورة، يجب إكمالها على نفس الجهاز.',
        question2: 'ماذا أفعل عندما أنهي الدورات؟',
        answer2:
            'عندما تكمل دورة، اضغط على زر الإنهاء وأكد أنك أتممت الدورة. تأكد من عدم وجود مهام مفتوحة أخرى.',
        question3: 'هل تحتاج للمساعدة؟',
        answer3:
            'لا تتردد في التواصل معنا عبر الهاتف على 9663062-052 أو عبر البريد الإلكتروني على info@nakarmedic.co.il',
    },
    gender: {
        male: 'ذكر',
        female: 'أنثى',
    },
    OrganizationsPage: {
        title: 'الوحدات التنظيمية الخاصة بي',
        subTitle: 'الإدارة والإعدادات',
        organizations: 'الوحدات التنظيمية التي أديرها',
        importUsersFile: 'استيراد ملف المستخدمين',
        editLogo: 'تحرير الشعار',
        dropLogoHere: 'اسحب الشعار إلى هنا',
        currentLogo: 'الشعار الحالي',
        changeForAllMyOrganizations: 'تغييره لجميع الوحدات التنظيمية التي أديرها',
        logoWillBeChangedForAllOrgs:
            '**سيتم تغيير الشعار لجميع الوحدات التنظيمية تحت إدارتك',
    },
    UsersPage: {
        title: 'المستخدمون',
        subTitle: 'الإدارة والإعدادات',
        userRowCourseMenu: {
            buttons: {
                addToCourse: 'تسجيل المستخدم',
                removeFromCourse: 'إزالة تسجيل المستخدم',
            },
        },
        userRowSignDocMenu: {
            buttons: {
                addToSignDoc: 'تسجيل المستخدم',
                removeFromSignDoc: 'إزالة التسجيل',
                markCompleted: 'تحديد كمكتمل',
            },
            tooltips: {
                sessionNotToday: 'يمكن تحديد الحضور فقط في يوم الجلسة'
            }
        },
    },
    organizationUserTable: {
        headers: {
            name: 'الاسم',
            permissions: 'الصلاحيات',
            identifier: 'المُعرّف',
        },
    },
    userType: {
        ADMIN: 'مدير',
        USER: 'مستخدم',
    },
    note: {
        title: 'العنوان',
        content: 'المحتوى',
        delete: 'حذف الملاحظة',
        assignToAllOrganizations: 'تعيين لجميع الوحدات التنظيمية',
        removeFromAllOrganizations: 'إزالة من جميع الوحدات التنظيمية',
        deleteNoteConfirmation: {
            title: 'حذف الملاحظة',
            message: 'هل أنت متأكد أنك تريد حذف هذه الملاحظة؟',
            noteName: 'اسم الملاحظة',
            deleteNote: 'حذف الملاحظة',
        },
    },
    organization: {
        organizationName: 'اسم الوحدة التنظيمية',
    },
    courseCard: {
        youAreDone: 'لقد أكملت الدورة',
        finishBy: (key, { finishByDate }) => `يجب إكمالها قبل ${finishByDate}`,
        youAreDoneWatchAgain: 'مشاهدة مرة أخرى',
        goToCourse: 'الانتقال إلى الدورة',
    },
    courseProgress: {
        notStarted: 'لم يبدأ',
        inProgress: 'قيد التقدم',
        finished: 'تم!',
    },
    ReportsPage: {
        title: 'التقارير',
        subTitle: 'عرض حالة إكمال الموظفين',
        courseLegend: {
            completed: 'مكتمل',
            inProgress: 'قيد التقدم',
            notStarted: 'لم يبدأ',
        },
        coursesStats: {
            title: 'حالة الإكمال لكل دورة',
        },
        signDocStats: {
            title: {
                course: 'حالة الإكمال لكل دورة',
                signDocs: 'حالة التوقيع لكل مستند',
            },
            exportToExcel: 'تصدير إلى Excel',
            exporting: 'جاري التصدير...',
            exportCurrentFilters: 'تصدير الفلاتر الحالية',
            graphs: {
                usersPerformanceNumbers: (key, { taskCount = 0 }) =>
                    `عدد المستخدمين حسب حالة الإكمال ${
                        taskCount ? `(${taskCount} مهام)` : ''
                    }`,
                usersPerformancePercent: (key, { taskCount = 0 }) =>
                    `نسبة المستخدمين حسب حالة الإكمال ${
                        taskCount ? `(${taskCount} مهام)` : ''
                    }`,
                performanceNumberByOrg: (key, { orgsCount = 0 }) =>
                    `عدد الإكمالات في الوحدة التنظيمية ${
                        orgsCount ? `(${orgsCount} وحدات تنظيمية)` : ''
                    }`,
                performancePercentByOrg: (key, { orgsCount = 0 }) =>
                    `نسبة الإكمال في الوحدة التنظيمية ${
                        orgsCount ? `(${orgsCount} وحدات تنظيمية)` : ''
                    }`,
                signDocsCount: ' مستندات للتوقيع',
                activeCourseCount: 'عناصر تعلم نشطة',
                usersCount: 'مستخدمون',
                usersWithActiveTasks: 'مستخدمون لديهم مهمة نشطة',
                allSignDocsOfACompanyCount: 'عناصر التعلم والتدريب',
                info: {
                    activeCourseCount:
                        'إجمالي عناصر التعلم ذات تاريخ نهاية مستقبلي (دورات، مستندات للتوقيع، ومهام المشاهدة)',
                    usersCount: 'إجمالي المستخدمين',
                    usersWithActiveTasks:
                        'إجمالي المستخدمين الذين لديهم على الأقل مهمة واحدة نشطة',
                    allSignDocsOfACompanyCount:
                        'إجمالي عناصر التعلم (الدورات والمستندات للتوقيع ومهام المشاهدة)',
                    performanceNumberByOrg:
                        'إجمالي المهام المكتملة من جميع المهام المتراكمة\n (المهام المتراكمة = عدد عناصر التعلم والتدريب مضروباً في عدد المستخدمين المسجلين لكل عنصر)',
                    performancePercentByOrg:
                        'إجمالي المهام المكتملة في كل وحدة تنظيمية',
                },
            },
        },
        tabs: {
            dashboard: 'لوحة المعلومات',
            allReports: 'تقارير التعلم والتدريب',
            courses: 'الدورات',
            signDocs: 'مستندات للتوقيع',
            exams: 'الاختبارات',
            learningPaths: 'مسارات التعلم',
            generatedReports: 'التقارير المُنشأة',
            KnowledgeCenter: 'مركز المعرفة',
            operation: 'التشغيل',
        },
    },
    learningPathReport: {
        status: {
            completed: 'مكتمل',
            inProgress: 'قيد التنفيذ',
            notStarted: 'لم يبدأ'
        }
    },
    courseReports: {
        title: 'تقارير الدورات',
        defaultTitle: 'دورة',
        subtitle: (key, { completed, assigned, rate }) => `${completed} من ${assigned} أكملوا (${rate}%)`,
        organization: 'الوحدة التنظيمية',
        allOrganizations: 'جميع الوحدات التنظيمية',
        completed: 'مكتمل',
        notFound: 'الدورة غير موجودة',
        card: {
            sessionDate: 'تاريخ الجلسة',
            noSessionDate: 'لم يتم تحديد التاريخ',
            viewFullReport: 'عرض التقرير الكامل',
            completionRate: 'نسبة الإكمال'
        },
        downloadReport: 'تحميل تقرير المهام',
        noCourses: {
            title: 'لا توجد دورات متاحة',
            message: 'لم يتم العثور على دورات للوحدات التنظيمية المحددة'
        }
    },
    signDocReports: {
        searchLabel: 'بحث',
        searchPlaceholder: 'البحث بالاسم...',
        filterByType: 'تصفية حسب نوع المحتوى',
        noSignDocs: {
            title: 'لا يوجد محتوى متاح',
            message: 'لم يتم العثور على محتوى للوحدات التنظيمية المحددة'
        }
    },
    courseProgressMgmnt: {
        notStarted: 'لم يبدأ',
        inProgress: 'قيد التقدم',
        finished: 'مكتمل',
        attended: 'حضر',
        noShow: 'لم يحضر',
        completedOn: 'تاريخ التوقيع: ',
        completedOnCourse: 'تاريخ الإكمال: ',
        by: 'من قِبل ',
        manual: 'يدوي',
        finishBy: 'يجب إكماله قبل: ',
    },
    examScore: 'النتيجة',
    LearningManagementPage: {
        title: 'إدارة التعلم',
        subTitle: 'إضافة، تحرير، وحذف',
        addCourse: 'إضافة دورة',
        editCourse: 'تحرير دورة',
        deleteCourse: 'حذف دورة',
        courseName: 'اسم الدورة',
        courseDescription: 'وصف الدورة',
        courseImage: 'صورة الدورة',
        createKnowledgeSource: 'إنشاء مصدر معرفة',
        createQuestionnaire: 'إنشاء استبيان',
        createExam: 'أنشئ اختبارًا',
        courseCard: {
            editCourse: 'تحرير الدورة',
        },
        signDocCard: {
            editSignDoc: {
                READ_AND_SIGN_DOC_PDF: 'تحرير المستند',
                WATCH_AND_SIGN_YOUTUBE_LINK: 'تحرير مهمة المشاهدة',
                WATCH_AND_SIGN_VIMEO_LINK: 'تحرير مهمة المشاهدة',
                WATCH_AND_SIGN_VIDEO_FILE: 'تحرير مهمة المشاهدة',
                REGULAR_COURSE: 'تحرير الدورة',
                CANVA_PRESENTATION: 'تحرير العرض التقديمي',
                EXAM: 'تحرير الامتحان',
                FRONTAL_COURSE: 'تحرير المحاضرة المباشرة',
                ONLINE_COURSE: 'تحرير الدورة عبر الإنترنت'
            },
            deleteModal: {
                title: 'حذف المستند',
                text: 'هل أنت متأكد أنك تريد حذف هذا المستند؟ لا يمكن التراجع عن هذا الإجراء',
                confirm: 'حذف المستند',
                cancel: 'إلغاء',
                signDocName: 'اسم المستند',
                deleteAllVersionsCheckbox: 'حذف جميع إصدارات هذا المستند',
                warningAllVersions: '⚠️ تحذير: حذف هذا المستند سيؤدي إلى حذف جميع إصدارات المستند'
            },
            versionManagement: 'إدارة الإصدارات',
        },
        users: {
            buttons: {
                downloadCsv: 'تصدير إلى CSV',
                downloadCsvForOrganizations: 'تنزيل تقرير المهام للمستخدمين من الوحدات التنظيمية المحددة',
                downloadUserDetailsForOrganizations:
                    'تنزيل ملف بيانات المستخدمين للوحدات التنظيمية المحددة',
                downloadSelectedUsers: 'تنزيل تقرير المهام للمستخدمين المحددين',
                downloadCsvForOrganization: 'تصدير المستخدمين للوحدة التنظيمية المحددة',
                downloadCsvForAllOrganizations:
                    'تصدير المستخدمين لجميع الوحدات التنظيمية التي أديرها',
            },
            messages: {
                exportStarted: 'بدأ التصدير. جاري الانتقال إلى التقارير...',
                exportFailed: 'فشل التصدير. يرجى المحاولة مرة أخرى.',
                noUsersSelected: 'يرجى تحديد المستخدمين للتصدير',
            }
        },
        courseManagement: 'إدارة الدورات',
        signDocManagement: 'إدارة المستندات',
        noSignDocs: 'لا توجد مستندات للعرض',
        noSearchResults: 'لم يتم العثور على نتائج لبحثك',
        noSearchResultsHint: 'حاول تعديل مصطلح البحث أو امسح البحث لرؤية جميع العناصر',
        tabs: {
            signDocs: 'مستندات للتوقيع',
            frontalCourses: 'تدريب مباشر',
            onlineCourses: 'تدريب عبر الإنترنت',
            courses: 'الدورات',
            users: 'المستخدمون',
            tasks: 'المهام',
            knowledgeCenter: 'مركز المعرفة',
            operation: 'التشغيل',
            questionnaire: 'استبيانات',
        },
        searchTasks: 'البحث في المهام',
        searchTasksPlaceholder: 'البحث بالاسم...',
        filterByType: 'تصفية حسب النوع',
        filterByTypePlaceholder: 'اختر الأنواع...',
        allTypes: 'كل الأنواع',
        typeNames: {
            READ_AND_SIGN_DOC_PDF: 'وثائق للتوقيع',
            WATCH_AND_SIGN_YOUTUBE_LINK: 'فيديوهات',
            WATCH_AND_SIGN_VIMEO_LINK: 'فيديوهات',
            WATCH_AND_SIGN_VIDEO_FILE: 'فيديوهات',
            VIDEOS: 'فيديوهات',
            REGULAR_COURSE: 'دورات',
            CANVA_PRESENTATION: 'عروض تقديمية',
            EXAM: 'اختبارات',
            LEARNING_PATH: 'مسارات التعلم',
            SURVEY: 'استبيانات',
            ARTICLE: 'مقالات',
            AUDIO_FILE: 'ملفات صوتية',
            LINK: 'روابط',
            PODCAST: 'بودكاست',
            FRONTAL_COURSE: 'دورات مباشرة',
            ONLINE_COURSE: 'دورات عبر الإنترنت',
            PRESENTATION: 'عروض تقديمية',
            WEEZBEE_COURSE: 'دورات',
            UPLOAD_DOCUMENT: 'تحميل المستندات',
        },
    },
    editCourseModal: {
        title: 'تحرير الدورة',
        courseName: 'اسم الدورة',
        courseDescription: 'وصف الدورة',
        courseImage: 'صورة الدورة',
        save: 'حفظ التغييرات',
        edit: {
            courseName: 'اسم الدورة',
            courseDescription: 'وصف الدورة',
            dateEditNotification:
                'يمكنك تعيين تاريخ انتهاء موحد لجميع المستخدمين المسجلين في الدورة في جميع الوحدات التنظيمية التي تديرها. أي تغيير هنا سيؤثر على التواريخ الفردية للمستخدمين.',
        },
        dateModal: {
            title: 'تعيين تاريخ الانتهاء',
            timeAndTimezone: 'حتى الساعة 00:00 في المنطقة الزمنية: ',
        },
    },
    editUserCourseModal: {
        title: (key, { userName, courseName }) =>
            `تعيين تاريخ انتهاء لدورة "${courseName}" للمستخدم "${userName}"`,
        dateEditNotification:
            'يمكنك تعيين تاريخ انتهاء للمستخدم. سيستمر هذا التغيير ما لم تقم بتغيير تاريخ الانتهاء لجميع الوحدات التنظيمية.',
    },
    AppSideMenu: {
        welcome: 'أهلاً وسهلاً',
    },
    superAdmin: {
        partnersTable: {
            columns: {
                clientSecretExpiresAt: 'انتهاء صلاحية مفتاح العميل',
            }
        },
        cronJobs: {
            sectionTitle: 'مهام مجدولة',
            runRecurringRenewal: 'تشغيل التجديد الدوري',
            running: 'جاري التشغيل...',
            renewalSuccess: 'اكتمل التجديد الدوري بنجاح',
            renewalError: 'فشل التجديد الدوري. تحقق من سجلات الخادم.',
        },
        assets: {
            title: 'إدارة الأصول',
            columns: {
                fileName: 'اسم الملف',
                type: 'النوع',
                company: 'الشركة',
                createdBy: 'تم إنشاؤه بواسطة',
                tags: 'العلامات',
                lastModified: 'آخر تعديل',
                download: 'تنزيل',
                thumbnail: 'معاينة'
            },
            filters: {
                companyName: 'اسم الشركة',
                type: 'نوع الملف',
                all: 'الكل',
                image: 'صورة',
                video: 'فيديو',
                clear: 'مسح التصفية',
                generalBank: 'البنك العام'
            },
            fileTypes: {
                image: 'صورة',
                video: 'فيديو',
                file: 'ملف'
            },
            download: 'تنزيل الملف',
            downloadError: 'خطأ في تنزيل الملف',
            loading: 'جاري التحميل...',
            thumbnailError: 'خطأ في تحميل المعاينة',
            thumbnail: 'معاينة الملف',
            upload: {
                title: 'تحميل إلى البنك العام',
                uploadButton: 'تحميل الأصل',
                cancel: 'إلغاء',
                upload: 'تحميل',
                dragDrop: 'اسحب وأفلت ملفًا هنا أو انقر لتحديد ملف',
                supportedTypes: 'أنواع الملفات المدعومة: الصور (.jpg, .png, .gif) والفيديوهات (.mp4, .mov, .avi)',
                presentationName: 'اسم العرض',
                presentationNamePlaceholder: 'أدخل اسمًا للملف',
                description: 'الوصف',
                descriptionPlaceholder: 'أدخل وصفًا للملف',
                noFileSelected: 'الرجاء تحديد ملف للتحميل',
                error: 'حدث خطأ أثناء تحميل الملف',
                uploading: 'جاري التحميل'
            },
            tags: {
                editTags: 'تحرير العلامات',
                enterTagsPlaceholder: 'أدخل العلامات مفصولة بفواصل',
                tagsHelperText: 'تساعد العلامات في تنظيم وإيجاد الأصول بسهولة',
                andMoreTags: (key, { count }) => `و ${count} أخرى`,
                noTags: 'لا توجد علامات',
                save: 'حفظ',
                cancel: 'إلغاء'
            }
        },
        courseTemplates: {
            title: 'قوالب الدورات',
            placeholder: 'وظائف قوالب الدورات ستكون متاحة قريبًا. ستتيح لك هذه الصفحة إنشاء وتحرير وإدارة قوالب الدورات التي يمكن استخدامها عبر المنصة.',
            columns: {
                templateName: 'اسم القالب',
                templateSubject: 'الموضوع',
                description: 'الوصف',
                createdBy: 'تم إنشاؤه بواسطة',
                isPubliclyAccessible: 'متاح للجميع',
                isReady: 'جاهز',
                actions: 'إجراءات'
            },
            buttons: {
                createTemplate: 'إنشاء قالب جديد',
                editTemplate: 'تحرير القالب',
                deleteTemplate: 'حذف القالب',
                viewTemplate: 'عرض القالب'
            },
            searchPlaceholder: 'البحث عن القوالب...',
            noTemplates: 'لم يتم العثور على قوالب. قم بإنشاء أول قالب لك بالنقر على الزر أعلاه.',
            fetchError: 'فشل تحميل القوالب. يرجى المحاولة مرة أخرى لاحقًا.',
            searchError: 'فشل البحث عن القوالب. يرجى المحاولة مرة أخرى لاحقًا.',
            deleteError: 'فشل حذف القالب. يرجى المحاولة مرة أخرى لاحقًا.',
            confirmDelete: 'هل أنت متأكد أنك تريد حذف هذا القالب؟'
        },
        editFFModal: {
            modalTitle: 'تحرير ميزات الشركة',
            editFeatures: 'تحرير الميزات',
            paths: {
                basic: 'أساسي',
                creator: 'منشئ',
                enterprise: 'مؤسسة'
            },
            deals: {
                messaging: 'الرسائل والتواصل',
                contentTypes: 'أنواع المحتوى',
                courses: 'الدورات والتدريب',
                automation: 'الأتمتة',
                advanced: 'ميزات متقدمة',
                organization: 'إدارة المنظمة',
                system: 'إعدادات النظام'
            },
            dealStatus: {
                allEnabled: 'الكل مفعّل',
                partiallyEnabled: 'مفعّل جزئياً',
                disabled: 'غير مفعّل'
            },
            featureFlags: {
                automationFF: 'الأتمتة',
                smsFF: 'الرسائل النصية القصيرة',
                whatsappFF: 'واتساب',
                emailFF: 'البريد الإلكتروني',
                signDocsFF: 'المهام',
                sendWelcomeMessageFF: 'إرسال رسائل ترحيبية للمستخدم الجديد',
                signDocsReadAndSignDocPdfFF: 'توقيع PDF',
                signDocsWatchAndSignYoutubeLinkFF: 'تأكيد مشاهدة Youtube',
                signDocsWatchAndSignVimeoLinkFF: 'تأكيد مشاهدة Vimeo',
                signDocsWatchAndSignVideoFileFF: 'تأكيد مشاهدة ملف فيديو',
                signDocCanvaPresentationFF: 'عرض Canva',
                regularCourseFF: 'دورات',
                notifyNewTaskToUserFF: 'إشعار المستخدم بمهمة جديدة',
                knowledgeCenterFF: 'مركز المعرفة',
                orgAdminMgmtFF: 'إدارة صلاحيات المدير',
                languagesFF: 'اللغات',
                examsFF: 'الامتحانات',
                weezbeeCourseFF: 'دورة ويزبي',
                AIFF: 'الذكاء الاصطناعي',
                learningPathFF: 'مسار التعلم',
                signDocsAudioFileFF: 'ملف صوتي',
                linkFF: 'الروابط',
                surveyFF: 'الاستطلاعات',
                recurringAutomationFF: 'الأتمتة المتكررة',
                uploadDocumentFF: 'تحميل المستندات',
                certificationFF: 'الشهادات',
                subAdminCanCreateOrgFF: 'يمكن للمسؤول الفرعي إنشاء وحدات تنظيمية',
                phoneE164MigrationFF: 'ترحيل تنسيق الهاتف E.164',
                bulkUserRefactorFF: 'إدارة المستخدمين بالجملة V2',
                operationModeFF: 'وضع التشغيل (إعادة تسمية مركز المعرفة)',
                mustDoComplianceFF: 'الامتثال الإلزامي'
            },
        },
        allUsersTable: {
            columns: {
                firstName: 'الاسم الأول',
                lastName: 'اسم العائلة',
                email: 'البريد الإلكتروني',
                phone: 'الهاتف',
                roles: 'الأدوار',
                identifier: 'المُعرّف',
                organization: 'الوحدة التنظيمية',
                id: 'المعرف',
                companyName: 'الشركة',
                yes: 'نعم',
                no: 'لا',
                isSuperAdmin: 'مدير نظام',
                isCompanyAdmin: 'مدير شركة',
                isDeleted: 'محذوف',
                edit: 'تحرير',
                permanentlyDelete: 'حذف نهائي',
                loginUrl: 'رابط الدخول',
                userCreatedSmsDate: 'تاريخ رسالة الترحيب',
            },
            buttons: {
                downloadCsvForOrganization: 'تنزيل ملف Excel للوحدة التنظيمية',
                downloadCsvForAllOrganizations:
                    'تنزيل ملفات Excel لجميع الوحدات التنظيمية التي أديرها',
                downloadCsvForOrganizationSuccess:
                    'سيتم تجهيز ملفاتك قريبًا للتحميل ضمن "القائمة -> إدارة الملفات"',
                deleteUsers: 'حذف المستخدمين',
                edit: 'تحرير',
            },
        },
        allOrgsTable: {
            columns: {
                orgName: 'اسم الوحدة التنظيمية',
                taxIdentifier: 'المعرف',
                companyId: 'معرف الشركة',
                orgAddress: 'العنوان',
                orgContactInfo: 'معلومات الاتصال',
                id: 'المعرف',
                companyName: 'اسم الشركة',
                delete: 'حذف',
            },
            deleteOrg: 'حذف الوحدة التنظيمية',
            deleteOrgTitle: 'حذف الوحدة التنظيمية: ',
            deleteOrgText: 'هل أنت متأكد أنك تريد حذف الوحدة التنظيمية',
            deleteOrgConfirm: 'حذف الوحدة التنظيمية',
        },
        createNewCourse: {
            title: 'إنشاء دورة جديدة',
            docName: 'اسم الدورة',
            courseDescription: 'وصف الدورة',
            create: 'إنشاء الدورة',
            companyName: 'اسم الشركة',
            dropZipHere: 'اسحب ملف ZIP الخاص بالدورة هنا أو انقر لتحديد ملف',
            modalTitle: 'إنشاء دورة جديدة',
            organizationsTable: {
                orgName: 'اسم الوحدة التنظيمية',
                addOrganization: 'إضافة الدورة للوحدة التنظيمية',
                removeOrganization: 'إزالة الدورة من الوحدة التنظيمية',
                onlyOneCompanyPerCourse:
                    'يمكن إضافة الدورة لشركة واحدة فقط، لذا لا يمكنك تغيير الشركة الآن',
            },
        },
        createNewCustomer: {
            modalTitle: 'إنشاء عميل جديد',
            companyName: 'اسم الشركة',
            userPrefix: 'بادئة المستخدم (فريدة لكل شركة - بالإنجليزية فقط)',
            identifier: 'المعرف',
            contactEmail: 'بريد التواصل',
            contactName: 'اسم جهة الاتصال',
            contactPhone: 'هاتف جهة الاتصال',
            userCreationTitle: 'إنشاء مستخدم أولي للشركة',
            detailsTitle: 'املأ تفاصيل الشركة',
            userPassword: 'كلمة مرور المستخدم (بالإنجليزية فقط)',
            userIdentifier: 'معرف المستخدم (بالإنجليزية فقط)',
            createCompany: 'إنشاء الشركة',
            userNameNoteNoPrefix:
                '*يجب إدخال بادئة المستخدم قبل إدخال اسم المستخدم',
            userNameNote: (key, { companyUsersPrefix, userIdentifier }) =>
                `*اسم المستخدم الذي سيتم إنشاؤه هو: ${companyUsersPrefix}-${
                    userIdentifier || '"User Identifier"'
                }`,
            userPrefixError: 'يجب أن تكون بادئة المستخدم بالإنجليزية فقط',
            userFirstName: 'الاسم الأول',
            userLastName: 'اسم العائلة',
            contactFirstName: 'الاسم الأول لجهة الاتصال',
            contactLastName: 'اسم العائلة لجهة الاتصال',
            countryCode: 'الدولة',
        },
        editCourse: {
            courseName: 'اسم الدورة',
            docName: 'اسم الدورة',
            courseDescription: 'وصف الدورة',
            description: 'وصف الدورة',
            companyName: 'اسم الشركة',
            dropZipHere:
                'اسحب ملف الـ ZIP الخاص بالدورة هنا أو انقر لتحديد ملف',
            dropZipNote:
                '**انتبه أنك في وضع التحرير، فإذا كان هناك ملف ZIP موجود بالفعل لهذه الدورة، فإن رفع ملف آخر سيستبدله**',
            saveChanges: 'حفظ التغييرات',
            modalTitle: 'تحرير الدورة',
        },
        editCustomer: {
            modalTitle: 'تحرير العميل',
            adminUserDetails: 'تفاصيل المستخدم الرئيسي',
            detailsTitle: 'تحرير تفاصيل الشركة',
            organizationsTitle: 'الوحدات التنظيمية للعميل',
            addOrganizations: 'إضافة وحدات تنظيمية للعميل',
            addOrganizationModal: {
                organizationsList: 'قائمة الوحدات التنظيمية',
                useCommaSeparatedValues:
                    'أدخل قيمًا مفصولة بفواصل، مثال: "المالية, المحاسبة, تطوير البرمجيات"',
                title: 'إضافة وحدات تنظيمية للعميل',
            },
            mfaForAllUsers: 'طلب مصادقة ثنائية لجميع مستخدمي الشركة',
        },
        coursesTable: {
            columns: {
                courseName: 'اسم المهمة',
                description: 'وصف المهمة',
                edit: 'تحرير',
                type: 'نوع المهمة',
                editCourse: 'تحرير الدورة',
                companyName: 'اسم الشركة',
                remove: 'حذف',
                uploadStatus: 'حالة التحميل',
            },
            uploadStatus: {
                READY: 'جاهز',
                UPLOADING: 'جاري التحميل...',
                FAILED: 'فشل',
            }
        },
        customersTable: {
            columns: {
                companyName: 'اسم الشركة',
                taxIdentifier: 'المعرف',
                edit: 'تحرير',
                editCompany: 'تحرير الشركة',
                smsQuota: 'رصيد الرسائل',
                userQuota: 'ائتمان المستخدمين',
                activeUsers: 'المستخدمين النشطين',
                featureFlags: 'الميزات',
                storageQuotaMB: 'التخزين (MB)',
                editQuota: 'تحرير الحصص',
                welcomeMessage: 'إرسال رسالة ترحيب',
                welcomeMessageSent: 'تم إرسال الرسالة',
                delete: 'حذف',
            },
            deleteCompany: {
                button: 'حذف',
                title: 'حذف الشركة نهائيًا',
                warning: 'يؤدي هذا إلى حذف الشركة وجميع بياناتها نهائيًا. لا يمكن التراجع عن هذا الإجراء.',
                backupNote: 'يتم نسخ سجلات تعلّم الشركة (بيانات UserSignDoc) احتياطيًا إلى S3 قبل الحذف.',
                confirmLabel: 'اكتب اسم الشركة أو المعرّف للتأكيد:',
                confirmPlaceholder: 'اسم الشركة أو المعرّف',
                cancel: 'إلغاء',
                confirm: 'حذف الشركة',
                deleting: 'جارٍ الحذف...',
                success: 'تم حذف الشركة بنجاح',
                error: 'فشل حذف الشركة. يرجى المحاولة مرة أخرى.'
            },
            quota: {
                editQuota: 'تحرير الحصص',
                editQuotaTitle: 'تحرير حصص الشركة',
                editCredits: 'تحرير الأرصدة',
                editUserQuota: 'حصة المستخدمين',
                MessagesCreditsToEdit: 'أرصدة الرسائل',
                storageQuotaToEdit: 'التخزين بالميغابايت',
            },
            welcomeMessage: {
                confirmTitle: 'إرسال رسالة ترحيب للشركة',
                confirmMessage: 'هل أنت متأكد من أنك تريد إرسال رسائل ترحيب لجميع المستخدمين في هذه الشركة؟',
                detailsTitle: 'تفاصيل رسالة الترحيب',
                sentDate: 'تاريخ الإرسال:',
                sentBy: 'أرسل بواسطة:',
                company: 'الشركة:'
            },
        },
    },
    dataGrid: {
        filters: {
            search: {
                input: 'بحث',
            },
        },
        filterLabels: {
            course: 'دورة',
            organization: 'الوحدة التنظيمية',
            company: 'الشركة',
            signDoc: 'المهام',
            fileType: 'نوع الملف'
        },
        footer: {
            rowsSelected: (key, {count}) => count === 1 ? 'تم اختيار صف واحد' : `تم اختيار ${count} صفوف`
        },
    },
    importUsersPage: {
        downloadExample: 'تنزيل ملف نموذج لإنشاء المستخدمين',
        downloadUsersAsCSV: 'تنزيل المستخدمين كملف CSV',
    },
    importUsersModal: {
        title: 'استيراد / تحرير المستخدمين والوحدات',
        tabs: {
            importUsers: {
                title: 'استيراد المستخدمين وإضافة وحدات',
            },
            reorganizeUsers: {
                title: 'استيراد المستخدمين وتغيير الوحدات',
            },
        },
        manyUsersMessage:
            'يبدو أن هناك عددًا كبيرًا من المستخدمين في الملف، قد يستغرق الاستيراد بضع دقائق. بعد النقر على إنشاء، يرجى إبقاء النافذة مفتوحة حتى يكتمل التحميل، ثم انتظر بضع دقائق أخرى حتى تنعكس جميع التغييرات في النظام.',
        users: {
            firstName: 'الاسم الأول',
            lastName: 'اسم العائلة',
            identifier: 'المعرف',
            phone: 'رقم الهاتف',
            email: 'البريد الإلكتروني',
            organizations: 'الوحدات التنظيمية',
            organizationsAliases: ['وحدة تنظيمية', 'المنظمات', 'منظمة', 'وحدات', 'وحدة'],
        },
        createUsers: 'إنشاء/تحرير المستخدمين',
        selectOrganization: 'اختر الوحدات التنظيمية التي سيتم إنشاء المستخدمين لها',
        selectOrganizationsToAdd: 'اختر الوحدات التنظيمية للإضافة',
        organization: 'الوحدة التنظيمية',
        newUsersWillBeCreatedAndOrganizationsWillBeAddedToAllUsers:
            'سيتم إضافة الوحدات التنظيمية لجميع المستخدمين الموجودين في الملف المرفق. المستخدمون غير الموجودين سيتم إنشاؤهم، والمستخدمون الموجودون سيتم تحديثهم.',
        newUsersWillBeCreatedAndOrganizationsWillBeOverride:
            'سيتم تغيير الوحدات التنظيمية لجميع المستخدمين في الملف المرفق (سيتم إزالة المستخدمين من الوحدات التي لم يتم اختيارها). المستخدمون غير الموجودين سيتم إنشاؤهم، والمستخدمون الموجودون سيتم تحديثهم.',
        errors: {
            missingMandatoryField: (key, { row }) =>
                `*حقول إلزامية مفقودة في الصف ${row}:`,
            twoSourcesForOrgs:
                'لا يمكنك اختيار الوحدات التنظيمية من مصدرين. يرجى إزالة الوحدات التنظيمية من الملف المستورد أو من الاختيار في أعلى الصفحة',
            removeOrgsFromFile: 'يرجى إزالة الوحدات التنظيمية من الملف المستورد',
            missingSourceForOrgs:
                'لم يتم اختيار أية وحدات تنظيمية للمستخدمين. يرجى اختيار الوحدات من أعلى الصفحة أو إضافتها في ملف الاستيراد.',
            missingSourceForOrgsSelectFromMultiSelect:
                'لم يتم اختيار أية وحدات تنظيمية للمستخدمين. يرجى اختيار الوحدات من القائمة في أعلى الصفحة.',
            noFirstNameColumn: 'يجب أن يتضمن الملف عمودًا باسم "First Name"',
            noLastNameColumn: 'يجب أن يتضمن الملف عمودًا باسم "Last Name"',
            emptyExcelFile: 'ملف Excel فارغ أو لا يحتوي على ورقة عمل',
            invalidExcelFile: 'ملف Excel تالف أو غير صالح، يرجى التحقق من الملف وحاول مرة أخرى',
            unsupportedFileType: 'نوع الملف غير مدعوم. يرجى تحميل ملف CSV أو Excel (.xlsx, .xls)',
            missingColumn: (key, {columnName}) => `يجب أن يتضمن الملف عمودًا باسم "${columnName}"`,
        },
    },
    uploadBox: {
        uploading: 'جارٍ رفع الملف...',
        uploaded: 'تم رفع الملف بنجاح',
        uploadFailed:
            'الملف غير صالح. يرجى التحقق من حجم الملف ونوعه وعدم تجاوز الحد المسموح.',
        maxFileSize: (key, { maxFileSize }) =>
            `الحد الأقصى المسموح به لحجم الملف هو ${maxFileSize}`,
        onlyFileTypes: (key, { fileTypes }) =>
            `أنواع الملفات المسموح برفعها: ${map(fileTypes, (fileType) => `${fileType}`).join(', ')}`,
    },
    completedCoursePage: {
        title: 'إكمال الدورة',
        subTitle: 'يرجى تأكيد أنك أنهيت الدورة',
        buttons: {
            confirmCourseCompletion: 'أؤكد أنني أكملت الدورة',
        },
        finishedSuccessfully: 'لقد أكملت الدورة بنجاح',
        oops: 'عذراً...',
        youGotLost: 'يبدو أنك تهت، استخدم القائمة للتنقل',
        courseCompletedSuccessfullyPopup: 'لقد أكملت الدورة بنجاح',
    },
    errors: {
        clientError: 'خطأ في البيانات المقدمة',
        serverError: 'خطأ في طلب الخادم',
        generalServerError:
            'خطأ عام في طلب الخادم، حاول إعادة تحميل الصفحة. إذا استمرت المشكلة، تواصل مع الدعم الفني.',
        notFound: 'المورد غير موجود',
        forbidden: 'ليس لديك صلاحية للوصول إلى هذا المورد',
        privateRouteUserNotLoggedIn:
            'المستخدم غير مسجل دخوله، لذلك لا يمكن عرض المحتوى. يرجى تسجيل الدخول ثم المحاولة مرة أخرى.',
        session_expired: 'انتهت صلاحية جلسة الاتصال الخاصة بك. يرجى تسجيل الدخول مرة أخرى للمتابعة.',
        too_many_requests: 'خطأ، لقد حاولت عدة مرات، يرجى المحاولة لاحقًا'
    },
    alertDialog: {
        ok: 'موافق',
        cancel: 'إلغاء',
    },
    orphanedUsers: {
        filterLabel: 'بدون انتماء لمؤسسة',
        alertMessage: 'مستخدمون نشطون غير منتمين لأي مؤسسة. للإصلاح: اختر "بدون انتماء لمؤسسة" في عامل التصفية، ثم اضغط على تعديل لكل مستخدم وقم بإسناده إلى مؤسسة.',
    },
    createEditUserModal: {
        editPhone: 'تعديل الهاتف',
        organizationsLabel: 'الوحدات التنظيمية',
        selectAllOrganizations: 'اختيار جميع الوحدات التنظيمية',
        identifier: 'المعرف',
        createUser: 'إنشاء مستخدم',
        saveFailed: 'فشل الحفظ. يرجى المحاولة مرة أخرى.',
        titleCreate: 'إنشاء/تحديث مستخدم',
        titleEdit: 'تحرير مستخدم',
        selectOrganization: 'اختر الوحدة التنظيمية',
        firstName: 'الاسم الأول',
        lastName: 'اسم العائلة',
        identifier: 'المعرف',
        phone: 'الهاتف',
        email: 'البريد الإلكتروني',
        editUser: 'تحرير مستخدم',
        deleteUserTitle: 'حذف مستخدم',
        sendWelcomeMessageConfirm: 'إرسال رسالة',
        deleteUserText: 'هل أنت متأكد أنك تريد حذف المستخدم',
        deleteOrgConfirm: 'حذف المستخدم',
        deleteUserButton: 'حذف مستخدم',
        userIsCompanyAdmin: 'مدير شركة',
        userIsOrgAdmin: 'مدير وحدة تنظيمية',
        userIsOrgAdminTooltip: 'لحذف هذا المستخدم، يجب أولاً إزالته من الأدوار الإدارية في جميع الوحدات التنظيمية',
        mfaRequired: 'مطلوب التحقق بخطوتين',
        sendWelcomeMessage: 'إرسال رسالة ترحيب أولية للمستخدم',
        save: 'حفظ/تحديث المستخدم',
        userWillBeEditedIfPhoneExists:
            'إذا كان رقم الهاتف مرتبطًا بمستخدم في الشركة مسبقًا، فسيتم تحديث هذا المستخدم والوحدات التنظيمية المنتسب إليها',
    },
    phoneEditModal: {
        title: 'تحرير رقم الهاتف',
        phoneLabel: 'رقم الهاتف',
        phonePlaceholder: 'أدخل رقم الهاتف',
        cancel: 'إلغاء',
        save: 'حفظ',
        errors: {
            phone_already_exists: 'رقم الهاتف هذا موجود بالفعل في النظام',
            phone_belongs_to_inactive_user: 'رقم الهاتف هذا ينتمي لمستخدم غير نشط',
            invalid_phone_format: 'صيغة رقم الهاتف غير صالحة',
            no_permission: 'لا يوجد إذن لتحديث رقم الهاتف',
            network_error: 'خطأ في الشبكة، يرجى المحاولة مرة أخرى',
            check_failed: 'فشل التحقق من التوفر، يرجى المحاولة مرة أخرى',
        },
    },
    recurringAtEditModal: {
        title: 'تعديل تاريخ الإصدار التالي',
        dateLabel: 'تاريخ الإصدار التالي',
        disclaimer: 'تغيير تاريخ الإصدار التالي سيُطبَّق على جميع المستخدمين المعينين لهذه المهمة.',
        cancel: 'إلغاء',
        save: 'حفظ',
        errors: {
            saveFailed: 'فشل في تحديث التاريخ، يرجى المحاولة مرة أخرى',
        },
    },
    allUsersTable: {
        columns: {
            firstName: 'الاسم الأول',
            lastName: 'اسم العائلة',
            email: 'البريد الإلكتروني',
            phone: 'الهاتف',
            roles: 'الأدوار',
            identifier: 'المعرف',
            organization: 'الوحدة التنظيمية',
            id: 'المعرف',
            edit: 'تحرير',
            delete: 'حذف',
            sendWelcomeMessage: 'إرسال رسالة ترحيب',
            progress: 'التقدم',
            notRegistered: 'غير مسجل في الدورة',
        },
        buttons: {
            deleteUsers: 'حذف المستخدمين',
        },
        filters: {
            allUsers: 'جميع المستخدمين',
            activeOnly: 'المستخدمون النشطون فقط',
            deletedOnly: 'المستخدمون المحذوفون فقط',
        }
    },
    removeCourseFromCompanyCol: {
        deleteCourseButton: 'حذف الدورة',
        removeCourseTitle: 'حذف الدورة',
        removeCourseText: 'هل أنت متأكد أنك تريد حذف الدورة',
        removeCourseConfirm: 'حذف الدورة',
    },
    CourseReminderNotificationButton: {
        alerts: {
            reminderSent: 'التذكيرات في طريقها!',
            reminderNotSent: 'حدث خطأ أثناء إرسال التذكير',
            sentMessages: 'تم إرسال الرسائل',
            notSentMessages: 'لم يتم إرسال الرسائل',
            notSentMessagesInfo:
                '* هناك سببان محتملان لعدم إرسال جميع الرسائل: عدم وجود معلومات اتصال أو رقم هاتف غير صحيح',
            sendToUsersWhoDidNotReceiveNotification:
                'إرسال تذكير للمستخدمين الذين لم يتلقوا تذكيراً بعد',
            sendToAllUsers:
                'إرسال تذكير لجميع مستخدمي الدورة الذين لم يكملوها بعد',
            error: 'خطأ',
            company_has_no_sms_quota:
                'الشركة لا تمتلك رصيدًا كافيًا من الرسائل، يرجى التواصل مع الدعم لشراء حزمة رسائل',
            user_already_received_welcome_message: 'المستخدم تلقى رسالة الترحيب بالفعل',
            general_error: 'حدث خطأ أثناء إرسال الإشعار، يرجى المحاولة مرة أخرى لاحقًا'
        },
    },
    FilesManagementPage: {
        title: 'إدارة الملفات',
        subTitle: 'عرض، إضافة، وتحرير',
        fileManagementTable: {
            columns: {
                fileName: 'رابط التحميل',
                presentationName: 'الاسم المعروض',
                isReady: 'جاهز للتحميل',
                companyName: 'الشركة',
                organizationNames: 'الوحدات التنظيمية',
                date: 'تاريخ الإنشاء',
                createdByUser: 'تم الإنشاء بواسطة',
            },
            download: 'تنزيل',
            inProgress: 'جاري الإنشاء',
            ready: 'جاهز للتحميل',
            allOrganizations: 'جميع الوحدات التنظيمية',
        },
    },
    SMSNotificationButton: {
        title: 'إرسال تذكير',
        subTitle: 'فورًا',
    },
    sendSMSModal: {
        title: 'لمن نذكّر؟',
        sms: 'رسالة نصية (SMS)',
        whatsapp: 'واتساب',
        email: 'بريد إلكتروني',
        selectMessageDeliveryWay: 'سيتم إرسال الرسائل عبر:',
        sendToOptions: {
            all: 'المستخدمون الذين لم يكملوا مهمة محددة',
            onlyNotNotified: 'جميع الذين لم يكملوا الدورة ولم يتلقوا تذكيراً',
            allWithAnyOpenTasks: 'المستخدمون الذين لديهم مهام مفتوحة',
            knowledgeCenter: 'مركز المعرفة',
            pleaseSelect: 'يرجى اختيار المجموعة التي تريد إرسال التذكير إليها',
            label: 'من؟',
        },
        taskOptions: {
            label: 'أي مهمة؟',
            pleaseSelect: 'يرجى اختيار الدورة التي تريد إرسال التذكير بشأنها',
        },
        organizationOptions: {
            label: 'أي وحدة تنظيمية؟',
            pleaseSelect: 'يرجى اختيار الوحدة التنظيمية التي تريد إرسال التذكير لها',
        },
        smsStatusInformation: {
            statusTitle: 'رائع!',
            statusUserToNotify: 'إذن، سنذكّر إجمالي ',
            bySMS: 'عبر الرسائل النصية',
            byWhatsApp: 'عبر الواتساب',
            byEmail: 'عبر البريد الإلكتروني',
            statusCompanyQuota: 'للعلم، بعد الإرسال سيبقى لديك ',
            SMSForUse: 'رسالة متاحة للاستخدام',
            employees: 'الموظفين',
            theyWillReceiveItAsFollowing: 'وسيتلقون الرسائل بالطرق التالية',
            existing: 'موجودون',
            usersDontHaveEmails: 'مستخدمون بدون عناوين بريد إلكتروني'
        },
        error: {
            noUsersToSendOnlyNotNotified:
                'لا يوجد مستخدمون لإرسال التذكير؛ جميع من لم يكمل الدورة قد تلقى تذكيراً بالفعل',
            notEnoughSMS:
                'ليس لديك رصيد كافٍ من الرسائل، يرجى التواصل مع الدعم لشراء حزمة رسائل',
            noUsersInCourse:
                'لا يوجد مستخدمون لإرسال التذكير؛ جميع المستخدمين في هذه الدورة أكملوها',
            youAreLeftWithQuota: 'لا يزال لديك',
            youNeed: 'وأنت تحتاج إلى ما مجموعه',
            toCompleteTheProcess: 'لإتمام العملية',
        },
        send: 'إرسال',
    },
    SADeleteUsersModal: {
        title: 'حذف المستخدمين',
        firstName: 'الاسم الأول',
        lastName: 'اسم العائلة',
        email: 'البريد الإلكتروني',
        phone: 'الهاتف',
        employeeID: 'رقم الموظف',
        idNumber: 'رقم الهوية',
        organizations: 'المنظمات',
        identifier: 'المعرف',
        message: (key, { userCount }) =>
            `هل أنت متأكد أنك تريد حذف المستخدمين الـ ${userCount} التالية؟`,
        deleteUsers: 'حذف المستخدمين',
        fetchError: 'خطأ في تحميل بيانات المستخدمين',
        deleteError: 'خطأ في حذف المستخدمين',
        deleting: 'جاري الحذف...',

        // Confirmation view
        confirmMessage: (key, {userCount}) => `هل أنت متأكد من أنك تريد حذف ${userCount} مستخدمين؟`,
        confirmHint: 'المستخدمون الذين هم مسؤولو منظمة لن يتم حذفهم وسيتم عرضهم في تقرير النتائج.',

        // Results view
        resultsTitle: 'نتائج الحذف',
        successTitle: 'اكتمل الحذف بنجاح',
        noDeletedTitle: 'لم يتم حذف أي مستخدمين',

        deletedUsersTitle: 'المستخدمون المحذوفون',
        skippedUsersTitle: 'المستخدمون المتخطّون',

        // Result messages
        successMessageOnly: (key, {deleted}) => `تم حذف ${deleted} مستخدمين بنجاح.`,
        noDeletedMessage: (key) => `لم يتم حذف أي مستخدمين.`,

        skippedExplanationTitle: 'لماذا لم يتم حذف المستخدمين؟',
        skippedExplanation: 'المستخدمون التاليون لم يتم حذفهم لأنهم مسؤولو منظمة أو لديهم قيود أخرى. لحذفهم، قم أولاً بإزالة أذونات المسؤول الخاصة بهم من جميع المنظمات ذات الصلة.',

        skipReason: 'السبب',
        reasons: {
            orgAdmin: 'مسؤول المنظمة',
            adminOf: 'مسؤول',
            self: 'لا يمكنك حذف نفسك',
            notFound: 'المستخدم غير موجود',
            // Deletion protection reasons from backend
            cannot_delete_self: 'لا يمكنك حذف نفسك',
            cannot_delete_superadmin: 'لا يمكن حذف المسؤول الفائق',
            cannot_delete_company_admin: 'لا يمكن حذف مدير الشركة',
            cannot_delete_organizational_admin: 'لا يمكن حذف مسؤول المنظمة',
            different_company: 'المستخدم ينتمي إلى شركة مختلفة',
            not_an_organizational_admin: 'أنت لست مسؤول منظمة',
            not_admin_of_all_user_organizations: 'أنت لست مسؤولاً عن جميع منظمات المستخدم',
            generic_error: 'لا يمكن حذف المستخدم'
        }
    },
    SARemoveUser: {
        permanentlyDeleteUser: 'حذف نهائي',
        deleteUserTitle: 'حذف المستخدم نهائيًا',
        deleteUserText: 'هل أنت متأكد أنك تريد حذف المستخدم نهائيًا',
        deleteOrgConfirm: 'حذف المستخدم نهائيًا',
    },
    SADeleteUsersPermanentlyModal: {
        title: 'حذف المستخدمين نهائيًا',
        firstName: 'الاسم الأول',
        lastName: 'اسم العائلة',
        email: 'البريد الإلكتروني',
        phone: 'الهاتف',
        employeeID: 'معرف الموظف',
        idNumber: 'رقم الهوية',
        organizations: 'المنظمات',
        identifier: 'المعرف',
        warningTitle: 'تحذير! إجراء لا رجعة فيه',
        warningMessage: (key, {userCount}) => `أنت على وشك حذف ${userCount} مستخدمين نهائيًا. لا يمكن التراجع عن هذا الإجراء وسيؤدي إلى إزالة المستخدمين نهائيًا من قاعدة البيانات.`,
        confirmationRequired: 'للتأكيد، اكتب النص التالي:',
        confirmationText: 'احذف نهائيا',
        confirmationPlaceholder: 'اكتب "احذف نهائيا" للتأكيد',
        deleteUsersPermanently: 'حذف المستخدمين نهائيًا',
        cancel: 'إلغاء',
        fetchError: 'خطأ في جلب بيانات المستخدم',
        deleteError: 'خطأ في حذف المستخدمين نهائيًا',
        deleting: 'جاري الحذف نهائيًا...',
        confirmationMismatch: 'النص المدخل غير مطابق. يرجى كتابة "احذف نهائيا" بالضبط.',
    },
    automations: {
        title: 'الأتمتة',
        subTitle: 'الإدارة والإعدادات',
        addAutomation: 'إضافة أتمتة',
        editAutomation: 'تحرير الأتمتة',
        deleteAutomation: 'حذف الأتمتة',
        automationName: 'اسم الأتمتة',
        automationDescription: 'وصف الأتمتة',
        automationImage: 'صورة الأتمتة',
        automationCard: {
            editAutomation: 'تحرير الأتمتة',
        },
        notifications: {
            title: 'إنشاء أتمتة',
            subTitle: 'لجدولة التذكيرات',
        },
        createAutomationModal: {
            weWillSendNotificationTo: 'سنرسل تذكيرًا لكل من لم يكمل الدورة ',
            allOrganizations: 'جميع الوحدات التنظيمية',
            organizationOptions: {
                label: 'أي وحدة تنظيمية؟',
                pleaseSelect: 'يرجى اختيار الوحدة التنظيمية التي تريد إرسال التذكير لها',
                error: 'يجب اختيار وحدة تنظيمية لإرسال التذكير',
            },
            taskOptions: {
                label: 'أي مهمة؟',
                pleaseSelect: 'يرجى اختيار المهمة التي تريد إرسال التذكير بشأنها',
                error: 'يجب اختيار دورة لإرسال التذكير',
            },
            selectHourLabel: 'في أي ساعة؟',
            selectHourError: 'يجب اختيار ساعة لإرسال التذكير',
            howManyDaysBefore: 'كم يومًا قبل؟',
            howManyDaysBeforeError: 'يجب تحديد عدد الأيام قبل الموعد النهائي',
            nameLabel: 'اسم الأتمتة',
            descriptionLabel: 'وصف الأتمتة',
            create: 'إنشاء الأتمتة',
        },
    },
    automationsTable: {
        columns: {
            automationName: 'اسم الأتمتة',
            description: 'وصف الأتمتة',
            organization: 'الوحدة التنظيمية',
            task: 'المهمة',
            when: 'متى؟',
            status: 'الحالة',
            how: 'كيف يُرسل؟',
            delete: 'حذف',
            edit: 'تحرير',
        },
        automationTypeBadge: {
            oneTime: 'قبل الانتهاء',
            recurring: 'متكررة'
        },
        status: {
            SCHEDULED: 'مجدول',
            COMPLETED: 'تم الإرسال',
            sentAndNotSent: (key, { sent, notSent }) =>
                `تم الإرسال لـ ${sent} ولم يُرسل لـ ${notSent}`,
        },
        sendType: {
            SMS: 'رسالة نصية',
            EMAIL: 'بريد إلكتروني',
            WHATSAPP: 'واتساب',
        },
        atHour: 'في الساعة',
        daysBefore: 'أيام قبل موعد انتهاء الدورة',
    },
    allOrganizations: 'جميع الوحدات التنظيمية',
    allSignDocs: 'جميع المهام',
    confirmationModal: {
        confirm: 'تأكيد',
        cancel: 'إلغاء',
    },
    deleteAutomationModal: {
        title: 'حذف الأتمتة',
        message: 'هل أنت متأكد أنك تريد حذف الأتمتة؟',
        deleteAutomation: 'حذف الأتمتة',
        automationName: 'اسم الأتمتة',
    },
    newDocSign: {
        buttonTitle: 'إنشاء مهمة جديدة',
        modal: {
            title: 'إنشاء مهمة جديدة',
            newVersionTitle: 'إنشاء إصدار جديد',
            editSignDocTitle: 'تحرير المهمة',
            docNameLabel: {
                'REGULAR_COURSE': 'اسم الدورة',
                'READ_AND_SIGN_DOC_PDF': 'اسم المستند',
                'WATCH_AND_SIGN_YOUTUBE_LINK': 'اسم الفيديو',
                'WATCH_AND_SIGN_VIMEO_LINK': 'اسم الفيديو',
                'WATCH_AND_SIGN_VIDEO_FILE': 'اسم الفيديو',
                'CANVA_PRESENTATION': 'اسم العرض التقديمي',
                'EXAM': 'اسم الاختبار',
                'LEARNING_PATH': 'اسم مسار التدريب',
                'PODCAST': 'اسم البودكاست',
                'AUDIO_FILE': 'اسم ملف الصوت',
                'FRONTAL_COURSE': 'اسم المحاضرة الأمامية',
                'ONLINE_COURSE': 'اسم الدورة عبر الإنترنت',
                'PRESENTATION': 'اسم العرض التقديمي',
                'ARTICLE': 'اسم المقال',
                'SURVEY': 'اسم الاستطلاع',
                'LINK': 'اسم الرابط',
                'UPLOAD_DOCUMENT': 'اسم المهمة',
            },
            docDescriptionLabel: {
                'REGULAR_COURSE': 'وصف المستند',
                'READ_AND_SIGN_DOC_PDF': 'وصف المستند',
                'WATCH_AND_SIGN_YOUTUBE_LINK': 'وصف الفيديو',
                'WATCH_AND_SIGN_VIMEO_LINK': 'وصف الفيديو',
                'WATCH_AND_SIGN_VIDEO_FILE': 'وصف الفيديو',
                'CANVA_PRESENTATION': 'وصف العرض التقديمي',
                'EXAM': 'وصف الاختبار',
                'LEARNING_PATH': 'وصف مسار التدريب',
                'PODCAST': 'وصف البودكاست',
                'AUDIO_FILE': 'وصف ملف الصوت',
                'FRONTAL_COURSE': 'وصف المحاضرة الأمامية',
                'ONLINE_COURSE': 'وصف الدورة عبر الإنترنت',
                'PRESENTATION': 'وصف العرض التقديمي',
                'ARTICLE': 'وصف المقال',
                'SURVEY': 'وصف الاستطلاع',
                'LINK': 'وصف الرابط',
                'UPLOAD_DOCUMENT': 'وصف المهمة',
            },
            createButtonText: {
                'REGULAR_COURSE': 'إنشاء دورة',
                'READ_AND_SIGN_DOC_PDF': 'إنشاء مستند',
                'WATCH_AND_SIGN_YOUTUBE_LINK': 'إنشاء مهمة مشاهدة',
                'WATCH_AND_SIGN_VIMEO_LINK': 'إنشاء مهمة مشاهدة',
                'WATCH_AND_SIGN_VIDEO_FILE': 'إنشاء مهمة مشاهدة',
                'AUDIO_FILE': 'إنشاء مهمة استماع',
                'CANVA_PRESENTATION': 'إنشاء عرض تقديمي',
                'EXAM': 'إنشاء اختبار',
                'LEARNING_PATH': 'إنشاء مسار تدريب',
                'PODCAST': 'إنشاء بودكاست',
                'FRONTAL_COURSE': 'إنشاء محاضرة أمامية',
                'ONLINE_COURSE': 'إنشاء دورة عبر الإنترنت',
                'PRESENTATION': 'إنشاء عرض تقديمي',
                'ARTICLE': 'إنشاء مقال',
                'SURVEY': 'إنشاء استطلاع',
                'LINK': 'إنشاء رابط',
                'UPLOAD_DOCUMENT': 'إنشاء مهمة تحميل',
            },
            dropDocLabel: {
                'READ_AND_SIGN_DOC_PDF': 'اسحب ملف PDF هنا أو انقر لتحديد ملف',
                'WATCH_AND_SIGN_VIDEO_FILE': 'اسحب ملف فيديو هنا أو انقر لتحديد ملف',
                'AUDIO_FILE': 'اسحب ملف صوتي هنا أو انقر لتحديد ملف',
                'UPLOAD_DOCUMENT': 'اسحب ملفًا هنا أو انقر لتحديد ملف',
            },
            examExtraSaveButton: 'حفظ ومتابعة تحرير الأسئلة',
            weezBeeCourseExtraSaveButton: 'حفظ ومتابعة تحرير الدورة',
            learningPathExtraSaveButton: 'حفظ ومتابعة تحرير مسار التدريب',
            surveyExtraSaveButton: 'حفظ ومتابعة تحرير الاستطلاع',
            createDocument: 'إنشاء مستند',
            createExam: 'إنشاء اختبار',
            createLearningPath: 'إنشاء مسار تدريب',
            dropSignDocHere: 'اسحب ملف المستند هنا أو انقر لتحديده',
            selectSignDocType: 'النوع',
            linkUrl: 'رابط',
            youtubeLinkNotAllowed: 'لا يمكنك إدخال رابط Youtube',
            vimeoLinkNotAllowed: 'لا يمكنك إدخال رابط Vimeo',
            canvaLinkNotAllowed: 'لا يمكنك إدخال رابط Canva',
            invalidLink: 'رابط غير صالح',
            notifyUsersOfNewTask: 'إرسال رسالة للمستخدمين حول مهمة جديدة',
            notifyUsersOfNewTaskTooltip: 'سيتم إرسال الرسالة فقط للمستخدمين الذين لم يتلقوا بعد إشعارًا بهذه المهمة',
            quotaWarning: {
                title: 'رصيد الرسائل غير كافٍ',
                message: (key, { quotaNeeded, quotaAvailable, totalUsers }) => `تحتاج إلى ${quotaNeeded} رسالة لإعلام ${totalUsers} مستخدمين، لكن يتوفر فقط ${quotaAvailable} رسالة.`,
                contactSupport: 'يرجى التواصل مع الدعم لشراء رسائل إضافية، أو إيقاف تشغيل الإشعارات للحفظ بدون إرسال.',
                disableNotificationToSave: 'أوقف الإشعارات لحفظ المستند',
            },
            forceCompletion: 'مطلوب الإكمال',
            nonForceCompletion: 'مركز المعرفة',
            noDate: 'بدون تاريخ انتهاء',
            isMustDo: {
                label: 'إلزامي للامتثال',
                tooltip: 'يجب على المستخدمين إكمال هذه المهمة لاجتياز فحص الامتثال الخارجي'
            },
            allowFastForward: {
                WATCH_AND_SIGN_VIDEO_FILE: 'السماح بالتقديم السريع في الفيديو',
                WATCH_AND_SIGN_YOUTUBE_LINK: 'السماح بالتقديم السريع في الفيديو',
                WATCH_AND_SIGN_VIMEO_LINK: 'السماح بالتقديم السريع في الفيديو',
                AUDIO_FILE: 'السماح بالتقديم السريع في ملف الصوت',
            },
            organizationAssignmentInfo: 'ستتمكن من تعيين المهمة للوحدات التنظيمية عند تحرير المهمة',
            assignToAllOrganizations: 'تعيين لجميع الوحدات التنظيمية',
            removeFromAllOrganizations: 'إزالة من جميع الوحدات التنظيمية',
            assignmentTabs: {
                organizations: 'تعيين للوحدات التنظيمية',
                individualUsers: 'تعيين فردي للمستخدمين'
            },
            assignmentSubTabs: {
                allUsers: 'جميع المستخدمين',
                selected: 'المحددون',
                noSelectedUsers: 'لم يتم تحديد مستخدمين'
            },
            recurring: {
                toggleLabel: 'تفعيل الدورية',
                toggleDescription: 'إنشاء إصدارات جديدة تلقائيًا على فترات منتظمة',
                frequencyLabel: 'الدورية',
                frequencyNote: 'سيتم إعادة تعيين المستخدمين إلى الإصدارات الجديدة وفقًا لهذا الجدول',
                nextVersionDate: 'سيتم إنشاء الإصدار التالي في',
                minimumFrequencyError: 'الحد الأدنى للدورية هو شهر واحد',
                nextVersionDateLabel: 'تاريخ الإصدار التالي',
                transitionDisclaimer: 'هذه المهمة تتحول من مهمة عادية إلى مهمة دورية. يجب اختيار تاريخ للإصدار التالي. سيتم تطبيق هذا التاريخ على جميع المستخدمين المعينين. بعد هذا التاريخ، سيتم إنشاء إصدارات جديدة تلقائيًا وفقًا للتردد المحدد. يمكنك تعديل التاريخ في أي وقت من صفحة إدارة الإصدارات.',
            },
            groupType: {
                label: 'التردد',
                SEQUENTIAL: 'دوري',
                PARALLEL: 'بدون تردد'
            },
            status: {
                label: 'الحالة',
                ACTIVE: 'نشط',
                ARCHIVED: 'مؤرشف'
            }
        },
    },
    signDocModal: {
        importUsers: {
            modalTitle: 'استيراد مستخدمين من ملف',
            importFromFile: 'استيراد من ملف',
            matchedUsers: 'مستخدمون متطابقون',
            unmatchedRows: 'صفوف غير متطابقة',
            addUsers: (key, {count}) => `إضافة ${count} مستخدمين`,
            noMatchesFound: 'لم يتم العثور على مستخدمين متطابقين',
            unmatchedRowsHint: 'لم تتطابق هذه الصفوف مع أي مستخدم في النظام. تحقق من صحة أرقام الهاتف.',
            processingFile: 'جاري معالجة الملف...',
            fileError: 'خطأ في قراءة الملف'
        }
    },
    signDocProgress: {
        notStarted: {
            READ_AND_SIGN_DOC_PDF: 'لم أقرأه',
            WATCH_AND_SIGN_YOUTUBE_LINK: 'لم أشاهده',
            WATCH_AND_SIGN_VIMEO_LINK: 'لم أشاهده',
            WATCH_AND_SIGN_VIDEO_FILE: 'لم أشاهده',
            AUDIO_FILE: 'لم أستمع',
            REGULAR_COURSE: 'لم أبدأ',
            CANVA_PRESENTATION: 'لم أشاهده',
            EXAM: 'لم أبدأ',
            LEARNING_PATH: 'لم أبدأ',
            LINK: 'لم أشاهده',
            SURVEY: 'لم أبدأ',
            WEEZBEE_COURSE: 'لم أبدأ',
            UPLOAD_DOCUMENT: 'لم أحمّل',
            FRONTAL_COURSE: 'لم أحضر',
            ONLINE_COURSE: 'لم أبدأ',
        },
        inProgress: {
            READ_AND_SIGN_DOC_PDF: 'قرأتُه',
            WATCH_AND_SIGN_YOUTUBE_LINK: 'بدأت',
            WATCH_AND_SIGN_VIMEO_LINK: 'بدأت',
            WATCH_AND_SIGN_VIDEO_FILE: 'بدأت',
            AUDIO_FILE: 'استمعتُ',
            REGULAR_COURSE: 'بدأت',
            CANVA_PRESENTATION: 'شاهدتُه',
            EXAM: 'بدأت',
            LEARNING_PATH: 'بدأت',
            LINK: 'زرتُه',
            SURVEY: 'بدأت',
            WEEZBEE_COURSE: 'بدأت',
            UPLOAD_DOCUMENT: 'حمّلت',
            FRONTAL_COURSE: 'مسجّل',
            ONLINE_COURSE: 'مسجّل',
        },
        finished: {
            READ_AND_SIGN_DOC_PDF: 'تم التوقيع!',
            WATCH_AND_SIGN_YOUTUBE_LINK: 'انتهيت!',
            WATCH_AND_SIGN_VIMEO_LINK: 'انتهيت!',
            WATCH_AND_SIGN_VIDEO_FILE: 'انتهيت!',
            AUDIO_FILE: 'انتهيت!',
            REGULAR_COURSE: 'انتهيت!',
            CANVA_PRESENTATION: 'تم التوقيع!',
            EXAM: 'انتهيت!',
            LEARNING_PATH: 'انتهيت!',
            LINK: 'قرأت!',
            SURVEY: 'انتهيت!',
            WEEZBEE_COURSE: 'انتهيت!',
            UPLOAD_DOCUMENT: 'تمت الموافقة',
            FRONTAL_COURSE: 'انتهيت!',
            ONLINE_COURSE: 'انتهيت!',
        }
    },
    signDocProgressMgmnt: {
        notStarted: 'لم يتم فتحه',
        inProgress: 'تم فتحه',
        finished: 'تم التوقيع',
    },
    signDocPage: {
        title: {
            read: {
                sign: 'الموافقة على قراءة المستند',
                noSign: 'قراءة المستند',
                knowledgeOnly: 'قراءة المستند',
            },
            watch: {
                sign: 'الموافقة على مشاهدة الفيديو',
                noSign: 'مشاهدة الفيديو',
                knowledgeOnly: 'مشاهدة الفيديو',
            },
            canva: {
                sign: 'الموافقة على مشاهدة العرض التقديمي',
                noSign: 'مشاهدة العرض التقديمي',
                knowledgeOnly: 'مشاهدة العرض التقديمي',
            },
        },
        subTitle: {
            read: {
                sign: 'وافق ووقّع أنك قرأت المستند',
                noSign: 'إعادة القراءة بعد التوقيع',
            },
            watch: {
                sign: 'وافق ووقّع أنك شاهدت الفيديو',
                noSign: 'إعادة المشاهدة بعد التوقيع',
            },
            canva: {
                sign: 'اطلع على كل العرض التقديمي ووقّع للتأكيد',
                noSign: 'إعادة المشاهدة بعد التوقيع',
            },
        },
        signatureTitle: {
            read: 'وقّع لتأكيد أنك قرأت المستند',
            watch: 'وقّع لتأكيد أنك شاهدت الفيديو',
            canva: 'وقّع لتأكيد أنك أكملت العرض التقديمي بالكامل',
        },
        signatureSubtitle: {
            read: 'لتأكيد قراءة المستند، وقّع هنا',
            watch: 'لتأكيد مشاهدة الفيديو، وقّع هنا',
            canva: 'لتأكيد إكمال العرض التقديمي، وقّع هنا',
        },
        signatureSubtitleNotCompleted: {
            read: 'بعد القراءة، ستظهر لوحة التوقيع وزر التأكيد',
            watch: 'بعد المشاهدة، ستظهر لوحة التوقيع وزر التأكيد',
            canva: 'بعد إكمال العرض التقديمي، ستظهر لوحة التوقيع وزر التأكيد',
        },
        iApproveReadingTheDoc: {
            read: 'لقد قرأت المستند!',
            watch: 'لقد شاهدت الفيديو!',
            canva: 'لقد أكملت العرض التقديمي!',
        },
        clear: 'مسح التوقيع',
    },
    signDocCard: {
        noDateSet: 'لم يتم تحديد تاريخ',
        youAreDone: {
            READ_AND_SIGN_DOC_PDF: 'لقد وقّعت المستند',
            WATCH_AND_SIGN_YOUTUBE_LINK: 'لقد شاهدت الفيديو',
            WATCH_AND_SIGN_VIMEO_LINK: 'لقد شاهدت الفيديو',
            WATCH_AND_SIGN_VIDEO_FILE: 'لقد شاهدت الفيديو',
            AUDIO_FILE: 'لقد استمعت إلى الملف الصوتي',
            REGULAR_COURSE: 'أكملت الدورة',
            CANVA_PRESENTATION: 'شاهدت العرض التقديمي',
            EXAM: 'أنهيت الامتحان',
            WEEZBEE_COURSE: 'أنهيت الدورة',
            LEARNING_PATH: 'أنهيت مسار التعلم',
            LINK: 'شاهدت الرابط',
            SURVEY: 'أنهيت الاستطلاع',
            UPLOAD_DOCUMENT: 'حملت المستند',
            FRONTAL_COURSE: 'حضرت المحاضرة',
            ONLINE_COURSE: 'أنهيت الدورة المباشرة',
        },
        finishBy: {
            READ_AND_SIGN_DOC_PDF: (key, { finishByDate }) =>
                `يجب توقيعه قبل ${finishByDate}`,
            WATCH_AND_SIGN_YOUTUBE_LINK: (key, { finishByDate }) =>
                `يجب مشاهدته قبل ${finishByDate}`,
            WATCH_AND_SIGN_VIMEO_LINK: (key, { finishByDate }) =>
                `يجب مشاهدته قبل ${finishByDate}`,
            WATCH_AND_SIGN_VIDEO_FILE: (key, { finishByDate }) =>
                `يجب مشاهدته قبل ${finishByDate}`,
            AUDIO_FILE: (key, { finishByDate }) =>
                `يجب الاستماع قبل ${finishByDate}`,
            REGULAR_COURSE: (key, { finishByDate }) =>
                `يجب الانتهاء حتى ${finishByDate}`,
            CANVA_PRESENTATION: (key, { finishByDate }) =>
                `يجب مشاهدته قبل ${finishByDate}`,
            EXAM: (key, {finishByDate}) => `يجب الانتهاء حتى ${finishByDate}`,
            WEEZBEE_COURSE: (key, {finishByDate}) => `يجب الانتهاء حتى ${finishByDate}`,
            LEARNING_PATH: (key, {finishByDate}) => `يجب الانتهاء حتى ${finishByDate}`,
            LINK: (key, {finishByDate}) => `يجب الزيارة قبل ${finishByDate}`,
            SURVEY: (key, {finishByDate}) => `يجب الانتهاء حتى ${finishByDate}`,
            UPLOAD_DOCUMENT: (key, {finishByDate}) => `يجب التحميل قبل ${finishByDate}`,
            FRONTAL_COURSE: (key, {finishByDate}) => `المحاضرة في: ${finishByDate}`,
            ONLINE_COURSE: (key, {finishByDate}) => `الدورة المباشرة في: ${finishByDate}`,
        },
        youAreDoneWatchAgain: {
            READ_AND_SIGN_DOC_PDF: 'اقرأ مرة أخرى',
            WATCH_AND_SIGN_YOUTUBE_LINK: 'شاهد مرة أخرى',
            WATCH_AND_SIGN_VIMEO_LINK: 'شاهد مرة أخرى',
            WATCH_AND_SIGN_VIDEO_FILE: 'شاهد مرة أخرى',
            REGULAR_COURSE: 'شاهد مرة أخرى',
            CANVA_PRESENTATION: 'شاهد مرة أخرى',
            FRONTAL_COURSE: 'شاهد التفاصيل مرة أخرى',
            ONLINE_COURSE: 'شاهد مرة أخرى',
        },
        goToCourse: {
            READ_AND_SIGN_DOC_PDF: 'اذهب للقراءة',
            WATCH_AND_SIGN_YOUTUBE_LINK: 'اذهب للمشاهدة',
            WATCH_AND_SIGN_VIMEO_LINK: 'اذهب للمشاهدة',
            WATCH_AND_SIGN_VIDEO_FILE: 'اذهب للمشاهدة',
            AUDIO_FILE: 'اذهب للاستماع',
            REGULAR_COURSE: 'الدخول إلى الدورة',
            CANVA_PRESENTATION: 'اذهب للمشاهدة',
            EXAM: 'الانتقال إلى الامتحان',
            WEEZBEE_COURSE: 'اذهب إلى الدورة',
            LEARNING_PATH: 'اذهب إلى المسار',
            LINK: 'اذهب إلى الرابط',
            SURVEY: 'اذهب إلى الاستطلاع',
            UPLOAD_DOCUMENT: 'اذهب إلى صفحة التحميل',
            FRONTAL_COURSE: 'المهمة مكتملة بالفعل',
            ONLINE_COURSE: 'اذهب إلى الدورة',
        },
        disabledButtonTooltips: {
            locked: 'المهمة مقفلة وغير متاحة الآن',
            surveyNotRedoable: 'الاستطلاع مجهول وقد تم إكماله بالفعل ولا يمكن إعادته',
            genericNotRedoable: 'المهمة مكتملة بالفعل',
            frontalCourseDisabled: 'يتم تحديد الحضور في المحاضرات الأمامية من قبل المسؤول فقط'
        },
        examScore: (key, { score }) => `النتيجة: ${score}`,
        completedByAdmin: 'أكمله المسؤول',
    },
    userSurveyAnswers: {
        modalTitle: (key, { userName }) => `إجابات المستخدم ${userName}`,
        columns: {
            question: 'سؤال',
            questionType: 'نوع السؤال',
            userAnswer: 'إجابة المستخدم',
            isCorrect: 'صحيح'
        },
        notApplicable: 'غير قابل للتطبيق',
        noAnswer: 'لم يُجب',
        unknownQuestion: 'سؤال غير معروف',
        unknownQuestionType: 'نوع سؤال غير معروف',
        unknownOption: 'خيار غير معروف',
        invalidRating: 'تقييم غير صالح',
        loading: 'جارٍ تحميل الإجابات...',
        error: 'خطأ في تحميل الإجابات',
        noQuestions: 'لم يتم العثور على أسئلة'
    },
    Errors_409: {
        storage_quota_error: (
            key,
            { bytesCompanyStorageQuota, bytesCompanyUsedStorage, bytesNewUsedStorage }
        ) => {
            const leftQuotaMB = '\u200E' + (
                (bytesCompanyStorageQuota - bytesCompanyUsedStorage) /
                (1024 * 1024)
            ).toFixed(2);
            const bytesNewUsedStorageMB = (
                bytesNewUsedStorage /
                (1024 * 1024)
            ).toFixed(2);
            const bytesCompanyStorageQuotaMB = (
                bytesCompanyStorageQuota /
                (1024 * 1024)
            ).toFixed(2);
            return `لا توجد مساحة تخزين كافية. حاول حذف بعض الملفات أو التواصل مع مدير النظام. لديك ${leftQuotaMB}MB متبقية من أصل ${bytesCompanyStorageQuotaMB}MB متاحة، وحجم الملف الذي تحاول رفعه هو ${bytesNewUsedStorageMB}MB.`;
        },
        missing_company_organization: 'يجب عليك اختيار وحدة تنظيمية للمستخدم',
        user_already_received_welcome_message: 'المستخدم قد استلم بالفعل رسالة الترحيب',
        company_has_no_sms_quota: 'لا تملك الشركة رصيد رسائل متاح، يرجى التواصل مع خدمة العملاء لشراء حزمة رسائل',
        original_password_dont_match: 'كلمة المرور المقدمة غير صحيحة',
        password_too_weak: 'كلمة المرور ليست قوية بما فيه الكفاية',
        organization_still_has_users: 'لا يزال هناك مستخدمون في المؤسسة يجب حذفهم أو نقلهم إلى مؤسسة أخرى',
    },
    signDocVersionManagement: {
        title: 'إدارة الإصدارات',
        managingVersionsFor: 'إدارة الإصدارات لـ',
        createNewVersionButton: 'إنشاء إصدار جديد',
        allVersions: 'جميع الإصدارات',
        archive: 'نقل إلى الأرشيف',
        currentVersion: 'الإصدار الحالي',
        versionNumber: 'رقم الإصدار',
        versionDetails: 'تفاصيل الإصدار',
        viewDetails: 'عرض التفاصيل',
        errorTitle: 'خطأ في تحميل الإصدارات',
        notFound: 'المستند غير موجود',
        notFoundDescription: 'المستند الذي تبحث عنه غير موجود أو تم حذفه',
        noVersions: 'لا توجد إصدارات للعرض',
        created: 'تاريخ الإنشاء',
        createdBy: 'أنشئ بواسطة',
        expiredAt: 'انتهت صلاحيته في',
        type: 'النوع',
        status: {
            label: 'الحالة',
            ACTIVE: 'نشط',
            ARCHIVED: 'مؤرشف',
            SCHEDULED: 'مجدول'
        },
        toggleStatus: 'انقر للتبديل بين الحالة (نشط/مؤرشف)',
        stats: {
            assigned: 'المعينون',
            completed: 'مكتمل',
            inProgress: 'قيد التنفيذ',
            completionRate: 'معدل الإنجاز',
            totalUsers: 'إجمالي المستخدمين'
        },
        statistics: {
            progressDone: 'التقدم المنجز',
            usersAssigned: 'المستخدمون المعينون',
            usersCompleted: 'المستخدمون الذين أكملوا',
            usersInProgress: 'المستخدمون في العملية'
        },
        viewStatistics: 'عرض الإحصائيات',
        userStatistics: 'إحصائيات المستخدمين',
        returnToData: 'العودة إلى البيانات',
        goToReports: 'الانتقال إلى التقارير',
        edit: 'تحرير',
        preview: 'معاينة',
        tabs: {
            versions: 'الإصدارات',
            recurringDetails: 'تفاصيل التكرار'
        },
        recurring: {
            title: 'إعدادات التكرار',
            notConfigured: 'هذا المستند غير مُعَد للتكرار',
            frequency: 'تكرار',
            nextVersionDate: 'تاريخ الإصدار التالي',
            editNextVersionDate: 'تعديل تاريخ الإصدار التالي',
            changeDate: 'تغيير التاريخ',
            everyXMonths: (key, { value }) => `كل ${value} شهر`,
            everyXYears: (key, { value }) => `كل ${value} سنة`,
            badge: 'مهمة متكررة',
        }
    },
    signDocPreviewPage: {
        title: 'معاينة المحتوى',
        loading: 'جاري تحميل المعاينة...',
        errorTitle: 'خطأ في المعاينة',
        errorDescription: 'تعذر تحميل معاينة المحتوى. قد لا يحتوي المستند على محتوى تم تحميله بعد.',
        noContent: 'لا يوجد محتوى متاح للمعاينة لهذا المستند.',
        backToVersions: 'العودة إلى الإصدارات',
    },
    signDocTypes: {
        READ_AND_SIGN_DOC_PDF: 'مستند PDF للتوقيع',
        WATCH_AND_SIGN_YOUTUBE_LINK: 'رابط Youtube للمشاهدة',
        WATCH_AND_SIGN_VIMEO_LINK: 'رابط VIMEO للمشاهدة',
        WATCH_AND_SIGN_VIDEO_FILE: 'ملف فيديو للمشاهدة',
        REGULAR_COURSE: 'دورة',
        CANVA_PRESENTATION: 'عرض Canva للمشاهدة',
        EXAM: 'امتحان',
        WEEZBEE_COURSE: 'دورة ويزبي',
        FRONTAL_COURSE: 'تدريب مباشر',
        ONLINE_COURSE: 'تدريب عبر الإنترنت'
    },
    signDocTypesNotForCompletion: {
        READ_AND_SIGN_DOC_PDF: 'مستند PDF',
        WATCH_AND_SIGN_YOUTUBE_LINK: 'رابط Youtube',
        WATCH_AND_SIGN_VIMEO_LINK: 'رابط VIMEO',
        WATCH_AND_SIGN_VIDEO_FILE: 'ملف فيديو',
        REGULAR_COURSE: 'دورة',
        CANVA_PRESENTATION: 'عرض Canva',
        EXAM: 'امتحان',
        WEEZBEE_COURSE: 'دورة ويزبي',
        LEARNING_PATH: 'مسار التعلم',
        AUDIO_FILE: 'ملف صوتي',
        LINK: 'رابط',
        SURVEY: 'استطلاع',
        UPLOAD_DOCUMENT: 'تحميل مستند',
        FRONTAL_COURSE: 'تدريب مباشر',
        ONLINE_COURSE: 'تدريب عبر الإنترنت',
    },
    managementCourseList: {
        signDocButtonTitle: 'إنشاء مهمة مشاهدة',
    },
    isCompanyAdmin: {
        makeAdmin: {
            title: 'تعيين كمدير للشركة',
            message: 'هل أنت متأكد أنك تريد تعيين المستخدم كمدير للشركة؟',
            confirm: 'تعيين كمدير للشركة',
            button: 'تعيين كمدير للشركة',
        },
        removeAdmin: {
            title: 'إزالة مدير الشركة',
            message:
                'هل أنت متأكد أنك تريد إزالة دور مدير الشركة من المستخدم؟',
            confirm: 'إزالة مدير الشركة',
            button: 'إزالة مدير الشركة',
        },
        userName: 'اسم المستخدم',
    },
    general: {
        saveChanges: 'حفظ التغييرات',
        close: 'إغلاق',
        cancel: 'إلغاء',
        save: 'حفظ',
        deleteConfirm: 'تأكيد الحذف؟',
        delete: 'حذف',
        areYouSure: 'هل أنت متأكد؟',
        copyOf: 'نسخة من',
        duplicating: 'جاري النسخ...',
        next: 'التالي',
        back: 'رجوع',
    },
    knowledgeCenter: {
        title: 'مركز المعرفة',
        subTitle: 'جميع المعلومات في مكان واحد',
    },
    operation: {
        title: 'التشغيل',
        subTitle: 'جميع معلومات التشغيل في مكان واحد',
    },
    adminUsersTable: {
        columns: {
            firstName: 'الاسم الأول',
            lastName: 'اسم العائلة',
            email: 'البريد الإلكتروني',
            phone: 'الهاتف',
            roles: 'الأدوار',
            identifier: 'المعرف',
            managerOfOrganizations: 'مدير في الوحدات التنظيمية',
            id: 'المعرف',
            edit: 'تحرير',
            isCompanyAdmin: 'مدير الشركة',
            isCompanyAdminYes: 'نعم',
            isCompanyAdminNo: 'لا',
        },
        addAdminUser: 'إضافة مدير',
    },
    editAdminUserModal: {
        title: 'تعيين مدير',
        titleEdit: 'تحرير المدير',
        sendWelcomeMessage: 'إرسال رسالة ترحيب أولية للمدير',
        save: 'حفظ التغييرات',
        selectOrganizationalUnits: 'البحث في الوحدات التنظيمية',
        searchUser: 'البحث عن مستخدم',
        isCompanyAdmin: 'مدير الشركة',
        companyAdminWillBeAdminOfAllOrgs:
            'سيكون مدير الشركة مديرًا لجميع الوحدات التنظيمية',
        selectAllOrgs: 'اختر جميع الوحدات التنظيمية',
    },
    autoComplete: {
        search: 'بحث',
        selectAll: 'اختر الكل',
        noOptions: 'لم يتم العثور على نتائج',
    },
    UserIconMenu: {
        settings: 'الإعدادات',
    },
    deletedUserTable: {
        emailNotAssigned: 'لم يتم إدخال البريد الإلكتروني',
        columns: {
            firstName: 'الاسم الأول',
            lastName: 'اسم العائلة',
            phoneNumber: 'الهاتف المحمول',
            email: 'البريد الإلكتروني',
            firstLoginDate: 'تاريخ الانضمام',
            deletedDate: 'تاريخ الحذف',
            userDetails: 'تفاصيل المستخدم'
        },
    },
    deletedUsersPage: {
        buttons: {
            downloadCsv: 'تصدير إلى CSV',
            downloadCsvForOrganizations: 'تصدير المستخدمين المحذوفين للوحدات التنظيمية المحددة',
            restoreUsers: 'استعادة المستخدمين',
        }
    },
    restoreUsersModal: {
        title: 'استعادة المستخدمين المحذوفين',
        resultsTitle: 'نتائج الاستعادة',
        confirmMessage: (key, {userCount}) => `أنت على وشك استعادة ${userCount} مستخدم(ين). هل تريد المتابعة؟`,
        confirmHint: 'سيُعاد ربط المستخدمين الذين تمت استعادتهم بالوحدات التنظيمية السابقة.',
        restoreUsers: 'استعادة المستخدمين',
        restoring: 'جارٍ الاستعادة...',
        restoreError: 'حدث خطأ أثناء استعادة المستخدمين. يرجى المحاولة مرة أخرى.',
        successMessage: (key, {restored}) => `تمت استعادة ${restored} مستخدم(ين) بنجاح`,
        noRestoredMessage: 'لم تتم استعادة أي مستخدم',
        restoredUsersTitle: 'المستخدمون الذين تمت استعادتهم',
        skippedUsersTitle: 'المستخدمون الذين تم تخطّيهم',
        skippedExplanationTitle: 'لماذا تم تخطّي بعض المستخدمين؟',
        skippedExplanation: 'تعذر استعادة بعض المستخدمين بسبب أخطاء داخلية. حاول مرة أخرى أو اتصل بالدعم إذا استمرت المشكلة.',
        firstName: 'الاسم الأول',
        lastName: 'اسم العائلة',
        email: 'البريد الإلكتروني',
        employeeID: 'رقم الموظف',
        idNumber: 'رقم الهوية',
        organizations: 'الوحدات التنظيمية',
        skipReason: 'السبب',
        reasons: {
            restore_failed: 'حدث خطأ أثناء الاستعادة',
        },
    },
    deletedUserModal: {
        title: 'المستندات والدورات التدريبية المرتبطة بـ',
        columns: {
            docName: 'اسم المهمة',
            status: 'الحالة',
            completedOnDate: 'تاريخ الانتهاء',
            type: 'نوع المهمة',
        },
        status: {
            finished: 'منتهي',
            inProgress: 'قيد التنفيذ',
            notStarted: 'لم يبدأ',
            signed: "موقّع"
        },
        signDocData: {
            unCompletedCourse: 'المهمة لم تكتمل',
        }
    },
    userDetailsModal: {
        learningPath: {
            expandTasks: 'عرض مهام مسار التعلم',
            collapseTasks: 'إخفاء مهام مسار التعلم'
        },
        progressSummary: {
            title: 'ملخص التقدم',
            completed: 'مكتمل',
            inProgress: 'قيد التقدم',
            notStarted: 'لم يبدأ',
            tasksCompleted: 'المهام المكتملة'
        },
        statusFilter: {
            archived: 'مؤرشفة'
        },
        archivedTag: 'مؤرشف',
        actions: {
            updateExpiryDate: 'تحديث تاريخ الانتهاء',
            declineApproval: 'رفض الموافقة',
            markAttended: 'وضع علامة حضور',
            markNoShow: 'وضع علامة غياب'
        }
    },
    FirstLoginModal: {
        title: 'يا سلام، بنبلّش نتعلّم سوا!',
        content: 'لازم تكمّل المهام المفتوحة بالشاشة الرئيسية لحدّ تاريخ الهدف.\n' +
            'بالتوفيق!',
        takeMeHome: 'رائع، خذوني عالشاشة الرئيسية'
    },
    organizationalUnitTable: {
        columns: {
            organizationalUnitName: 'اسم الوحدة التنظيمية',
            createAt: 'تاريخ الإنشاء',
            details: 'تفاصيل',
            delete: 'حذف',
            userCount: 'عدد المستخدمين',
            updateOrgName: 'تحديث أسماء الوحدات التنظيمية',
        },
        removeOrgCell: {
            columns: {
                firstName: 'الاسم الأول',
                lastName: 'اسم العائلة',
                organizationChange: 'تغيير الوحدة التنظيمية',
                deleteUser: 'حذف المستخدم'
            },
            modalNotAllowedDeleteTitle: 'لحذف وحدة تنظيمية، يجب إعادة تعيين جميع المستخدمين إلى وحدة أخرى على الأقل أو حذفهم.',
            modalAllowDeleteTitle: 'لا يوجد مستخدمون في المنظمة، يمكنك حذفها.',
            button: 'حذف الوحدة التنظيمية',
            tooltipMessage: 'لحذف المنظمة، يجب عليك حذف أو إخراج جميع المستخدمين منها.',
            alertErrorDeleteOrgTitle: 'خطأ في حذف المنظمة',
            failedDeleteOrgError: 'لم نتمكن من حذف المنظمة، نأسف! يرجى تحديث الصفحة والمحاولة مرة أخرى.'
        },
        editOrgNameCell: {
            button: 'تحديث اسم الوحدة التنظيمية',
        }
    },
    questionnaire: {
        buttons: {
            continueToQuestionPool: 'احفظ وتابع لتحرير الأسئلة',
        },
        modal: {
            title: 'إنشاء استبيان جديد',
            passGrade: 'علامة النجاح',
            timeToFinish: 'وقت الامتحان',
            canUserReview: 'هل يُسمح للممتحن بمراجعة الإجابات',
            allowedTries: 'عدد المحاولات المسموح بها'
        }
    },
    questionnaireQuestions: {
        validation: {
            modalTitle: 'يرجى تصحيح الأخطاء التالية قبل حفظ الاختبار',
            questionIndexError: 'خطأ في السؤال رقم',
            closeAndFix: 'أغلق وقم بالإصلاح',
            navigateToQuestion: 'انتقل إلى السؤال',
            minimumOptions: 'هناك أقل من خيارين للإجابة الصحيحة على السؤال',
            noCorrectAnswer: 'لم يتم اختيار إجابة صحيحة للسؤال',
            duplicateOptions: 'يوجد خياران بإجابة متطابقة',
        },
        aiLoadingTexts: {
            loading: 'نقوم بإنشاء أسئلة لك...',
            pleaseWait: 'يرجى الانتظار...',
            testWillBeReadySoon: 'اختبارك سيكون جاهزًا قريبًا...',
            aBitMorePatience: 'قليل من الصبر...',
            itMightTakeABitLongerButItsWorthIt: 'قد يستغرق الأمر بضع ثوانٍ إضافية، لكنه يستحق ذلك...',
        },
        tooltip: {
            pleaseFillSubject: 'يرجى إدخال موضوع الاختبار',
        },
        placeHolders: {
            subject: '*موضوع الاختبار',
            description: 'وصف قصير',
            question: 'سؤال',
            FREE_TEXT: 'نص إجابة قصيرة',
            option: 'خيار',
            NO_ANSWER: 'هذا القسم مخصص للمعلومات فقط ولن تكون هناك طريقة للإجابة عليه',
            questionCount: 'عدد الأسئلة',
        },
        question: 'سؤال',
        FREE_TEXT: 'نص إجابة قصيرة',
        option: 'خيار',
        NO_ANSWER: 'هذا القسم مخصص للمعلومات فقط ولن تكون هناك طريقة للإجابة عليه',
        messages: {
            deleteLastQuestion: 'لا يمكن حذف السؤال الأخير',
        },
        headers: {
            poolQuestion: 'تحرير الاختبار',
            poolQuestionSubTitle: 'عدد الأسئلة التي تم إنشاؤها للاختبار',
        },
        buttons: {
            addOption: 'أضف خيار +',
            saveQuestions: 'احفظ الأسئلة',
            saveQuestionsSubTitle: 'حفظ جميع الأسئلة في الاختبار',
            genAIQuestions: 'إنشاء أسئلة بالذكاء الاصطناعي',
        },
        aiModal: {
            questionQuantityLabel: 'عدد الأسئلة المراد إنشاؤها',
        },
        questionOptions: {
            MULTIPLE_CHOICE: 'اختيار واحد',
            CHECKBOX: 'اختيارات متعددة',
            FREE_TEXT: 'سؤال مفتوح',
            NO_ANSWER: 'فقرة قصيرة',
            RATING_SCALE: 'مقياس التقييم',
        },
        survey: {
            anonymousToggle: 'استطلاع مجهول',
            anonymousDescription: 'عند التفعيل، لن يتم حفظ تفاصيل المستخدمين الذين ملأوا الاستطلاع',
            ratingScale: {
                title: 'إعدادات مقياس التقييم',
                minValue: 'القيمة الدنيا',
                maxValue: 'القيمة القصوى',
                minLabel: 'تسمية الحد الأدنى',
                maxLabel: 'تسمية الحد الأقصى',
                defaultMinLabel: 'غير راضٍ',
                defaultMaxLabel: 'راضٍ جدًا',
                previewTitle: 'معاينة',
            }
        },
        addImage: 'إضافة صورة للسؤال',
        hasImage: 'السؤال يحتوي على صورة',
        dropImageOrClick: 'اسحب الصورة هنا أو انقر للاختيار',
        uploading: 'جارٍ تحميل الصورة...',
        supportedFormats: 'التنسيقات المدعومة',
        confirmDeleteImage: 'هل أنت متأكد أنك تريد حذف الصورة؟',
        errors: {
            invalidImageType: 'نوع ملف غير مدعوم. يرجى تحميل صورة بتنسيق JPG أو PNG أو GIF أو WEBP',
            imageTooLarge: 'حجم الملف يتجاوز 10 ميجابايت',
            uploadFailed: 'فشل تحميل الصورة',
            deleteFailed: 'فشل حذف الصورة',
        }
    },

    questionnaireSession: {
        modal: {
            finishExam: 'هل أنت متأكد أنك تريد إنهاء الاختبار؟',
            finishExamTitle: 'إنهاء الاختبار',
            finishExamWithUnansweredQuestions: 'هل أنت متأكد أنك تريد الانتهاء؟ هناك أسئلة لم يتم الإجابة عليها',
            closeAndReturnToTest: 'العودة إلى الاختبار'
        },
        finishModal: {
            congratsTitle: 'أحسنت!',
            congratsMessage: 'لقد اجتزت الاختبار بنجاح',
            oopsTitle: 'عذراً...',
            oopsMessage: 'يبدو أنك لم تجتاز الاختبار',
        },
        buttons: {
            previousQuestion: 'السؤال السابق',
            nextQuestion: 'السؤال التالي',
            finishExam: 'إنهاء الاختبار',
            congratsModal: 'رائع، خذني إلى الشاشة الرئيسية',
            oopsBackToHomePage: 'العودة إلى الشاشة الرئيسية',
        },
        errors: {
            notAllQuestionsAnswered: 'لم يتم الإجابة على جميع الأسئلة. هل أنت متأكد أنك تريد الانتهاء؟',
        },
    },
    surveySession: {
        finishModal: {
            congratsTitle: 'شكراً جزيلاً!',
            congratsMessage: 'شكراً جزيلاً لمشاركتك في الاستطلاع! \n مساهمتك مهمة جداً بالنسبة لنا.',
        },
        defaultTitle: "استطلاع",
        buttons: {
            previousQuestion: "السؤال السابق",
            nextQuestion: "السؤال التالي",
            finishSurvey: "إنهاء الاستطلاع",
            congratsModal: 'رائع، خذني إلى الشاشة الرئيسية',
        },
        placeHolders: {
            FREE_TEXT: 'إجابتك',
        },
        modal: {
            finishSurveyTitle: "إنهاء الاستطلاع",
            finishSurvey: "هل أنتم متأكدون أنكم تريدون إنهاء الاستطلاع؟ يمكنكم العودة وتغيير الإجابات قبل الانتهاء.",
            closeAndReturnToSurvey: "العودة إلى الاستطلاع"
        },
        success: {
            title: "شكراً جزيلاً!",
            anonymousMessage: "تم حفظ إجاباتكم بشكل مجهول",
            identifiedMessage: "تم حفظ إجاباتكم بنجاح في النظام",
            thankYou: "شكراً لكم على مشاركتكم في الاستطلاع! مساهمتكم مهمة جداً بالنسبة لنا.",
            anonymousConfirmation: "تم حفظ معلوماتكم بشكل مجهول ولا يمكن التعرف عليكم",
            goHome: "العودة إلى الصفحة الرئيسية"
        }
    },
    surveyInstruction: {
        title: 'قبل أن نبدأ، بعض النقاط المهمة...',
        info1:(key, {numberOfQuestions}) =>  `يتكون الاستطلاع من ${numberOfQuestions} أسئلة`,
        info2: 'نسعد بسماع رأيكم',
        info3: 'المشاركة في الاستطلاع طوعية',
        info4: 'يمكنكم تخطي الأسئلة التي لا ترغبون في الإجابة عليها',
        anonymous: "الاستطلاع مجهول تماماً",
        anonymousNotice: "ستُحفظ إجاباتكم بشكل مجهول ولن يكون من الممكن معرفة أي إجابات أجبتم عليها بأي شكل من الأشكال",
        thankYou: 'شكراً جزيلاً على مشاركتكم!',
        startButton: 'ابدأ الاستطلاع'
    },
    questionnaireInstruction: {
        title: 'قبل أن نبدأ، بعض النقاط المهمة...',
        info1:(key, {numberOfQuestions}) =>  `يتكون الاختبار من ${numberOfQuestions} أسئلة`,
        info2:(key, {passGrade}) =>  `الدرجة المطلوبة للنجاح في الاختبار - ${passGrade}`,
        info3: 'يجب الإجابة على جميع الأسئلة قبل التقديم',
        successInfo: 'نجحت؟ ',
        failInfo: 'لم تنجح؟ ',
        info4: 'رائع، لقد أنهيت المهمة. ',
        info5: 'يجب إعادة الاختبار',
        goodLuck: 'حظاً موفقاً!',
        startButton: 'ابدأ'
    },
    signDoc: {
        finishByDuration: {
            toggleLabel: 'تحديد وقت لإنجاز المهمة',
            title: 'الوقت للإكمال',
            note: 'عدد الأيام المتاحة للمستخدم لإكمال المهمة من وقت التعيين'
        },
        assignmentWarning: {
            title: 'تحذير التخصيص',
            editingWillBeLocked: 'تحذير: بمجرد تعيين هذا المستند للوحدات التنظيمية، سيتم قفل تحرير الأسئلة للحفاظ على سلامة التدريب.',
            editingLocked: 'يرجى ملاحظة: تحرير الأسئلة غير مسموح بسبب التعيينات السابقة للوحدات التنظيمية.',
            continueAssignment: 'متابعة التعيين',
            cancel: 'إلغاء'
        },
        organizationAssignmentWarning: {
            title: 'لم يتم اختيار وحدات تنظيمية',
            message: 'لم تقم بتعيين هذه المهمة لأي وحدة تنظيمية. هذا يعني أن المستخدمين لن يكونوا قادرين على رؤية أو إتمام هذه المهمة.',
            description: 'لجعل هذه المهمة مرئية للمستخدمين، تحتاج إلى تعيينها لوحدة تنظيمية واحدة على الأقل.',
            goBack: 'العودة',
            continueWithoutAssignment: 'المتابعة بدون تعيين'
        },
        editDisabled: {
            assignedToOrganizations: 'التحرير معطل لأن هذا المستند تم تعيينه للوحدات التنظيمية. هذا يحافظ على سلامة التدريب ويضمن التقييم المتسق.',
            editQuestionsDisabled: 'تحرير الأسئلة معطل للمستندات المخصصة للوحدات التنظيمية'
        },
        sequentialActiveVersionModal: {
            title: 'استبدال الإصدار النشط؟',
            message: (key, {activeVersionName}) => `"${activeVersionName}" هو الإصدار النشط الحالي لهذا المحتوى المتكرر.`,
            subMessage: 'يمكن أن يكون إصدار واحد فقط نشطًا في كل مرة. تفعيل هذا الإصدار سيؤدي إلى أرشفة السابق. المستخدمون المعينون للإصدار السابق سيتم تعيينهم أيضًا للإصدار الجديد، وسيظهر الإصدار السابق في منطقة الأرشيف الخاصة بهم.',
            declineButton: 'إلغاء',
            agreeButton: 'استبدال وتفعيل'
        }
    },
    weezbeeCourse: {
        addContent: 'إضافة محتوى',
        contentType: 'نوع المحتوى',
        contentTypes: {
            text: 'نص',
            video: 'فيديو',
            image: 'صورة',
            quiz: 'اختبار',
            pdf: 'PDF'
        },
        orientationOverlay: {
            title: 'يرجى تدوير جهازك',
            message: 'للحصول على تجربة أفضل، يرجى تدوير جهازك إلى الوضع الأفقي.'
        },
        fullscreenPrompt: {
            title: 'عرض الدورة في وضع ملء الشاشة',
            buttonText: 'دخول وضع ملء الشاشة',
            errors: {
                permissionDenied: 'تم رفض الإذن. يرجى المحاولة مرة أخرى بالنقر على زر ملء الشاشة.',
                generic: 'خطأ في ملء الشاشة: {message}'
            }
        },
        chapterPanel: {
            title: 'فصول للتنفيذ',
            generating: 'جاري الإنشاء...',
            aiCreating: 'الذكاء الاصطناعي ينشئ هذا الفصل...',
            deleteChapter: 'حذف الفصل',
            duplicateChapter: 'تكرار الفصل',
            copySuffix: '(نسخة)',
        },
        question: {
            defaultText: 'أدخل سؤالك هنا',
            tryAgain: 'عذراً، إجابة خاطئة. حاول مرة أخرى!',
            submitAnswer: 'إرسال الإجابة',
            correct: 'صحيح!',
            incorrect: 'غير صحيح',
        },
        navigation: {
            back: 'السابق',
            next: 'التالي'
        },
        aiGeneration: {
            generateCourse: 'إنشاء دورة باستخدام الذكاء الاصطناعي',
            courseLengthMinutes: 'مدة الدورة (بالدقائق)',
            courseLengthMinutesHelp: 'أدخل قيمة بين 5-30 دقيقة',
            descriptionPlaceholder: 'وصف موجز للدورة...',
            tooltip: {
                pleaseEnterDescription: 'يرجى إدخال وصف للدورة (5-150 حرفًا)',
                pleaseEnterValidCourseLength: 'يرجى إدخال مدة صالحة للدورة (5-30 دقيقة)'
            },
            loadingTexts: {
                loading: 'جاري إنشاء دورة لك...',
                pleaseWait: 'يرجى الانتظار...',
                courseWillBeReadySoon: 'ستكون دورتك جاهزة قريبًا...',
                aBitMorePatience: 'قليل من الصبر...',
                itMightTakeABitLongerButItsWorthIt: 'قد يستغرق الأمر بضع ثوانٍ إضافية، لكنه يستحق ذلك...',
            },
        },
        aiWizard: {
            openWizardButton: 'إنشاء دورة باستخدام الذكاء الاصطناعي',
            wizardTitle: 'معالج إنشاء الدورة بالذكاء الاصطناعي',
            step1Label: 'تفاصيل الدورة',
            step2Label: 'اختر قالب',
            subjectLabel: 'موضوع الدورة',
            subjectPlaceholder: 'أدخل الموضوع الرئيسي للدورة...',
            promptLabel: 'تعليمات إضافية للذكاء الاصطناعي (اختياري)',
            promptPlaceholder: 'قدم أي تعليمات محددة للذكاء الاصطناعي...',
            uploadFileButton: 'تحميل ملف مرجعي (PDF/TXT)',
            fileUploaded: 'تم تحميل الملف: {fileName}',
            removeFile: 'إزالة الملف',
            characterLimitExceeded: 'تم تجاوز حد الأحرف. يرجى تقليل المحتوى.',
            subjectRequired: 'موضوع الدورة مطلوب',
            validationError: 'يرجى إصلاح الأخطاء قبل المتابعة',
            fileTooLarge: 'الملف كبير جداً. الحد الأقصى: {maxSize}MB',
            unsupportedFileType: 'نوع الملف غير مدعوم. يرجى تحميل ملف PDF أو TXT',
            fileReadError: 'خطأ في قراءة الملف. يرجى المحاولة مرة أخرى',
            extractingFile: 'جاري استخراج النص من الملف...',
            generateButton: 'إنشاء الدورة',
            generatingButton: 'جاري الإنشاء...',
        },
        content: {
            title: 'عنوان',
            description: 'وصف',
            text: 'محتوى نصي',
            videoUrl: 'رابط الفيديو',
            addQuestion: 'إضافة سؤال',
            question: 'سؤال',
            option: 'خيار {number}',
            correctAnswer: 'الإجابة الصحيحة'
        },
        editor: {
            pagination: {
                pageInfo: (key, {current, total}) => `صفحة ${current} من ${total}`
            },
            backgroundSelector: {
                image: 'صورة',
                video: 'فيديو'
            },
            addSection: 'إضافة قسم',
            editSection: 'تحرير القسم',
            preview: 'معاينة',
            switchToViewMode: 'التبديل إلى وضع العرض',
            switchToEditMode: 'التبديل إلى وضع التحرير',
            enterFullscreen: 'ملء الشاشة',
            exitFullscreen: 'الخروج من ملء الشاشة',
            saveCourse: 'حفظ الدورة',
            saveCourseSubTitle: 'انقر لحفظ الدورة',
            previewMode: 'وضع المعاينة',
            editMode: 'وضع التحرير',
            componentBank: {
                title: 'بنك المكونات',
                description: 'اسحب أو انقر لإضافة المكونات',
                text: {
                    name: 'نص',
                    description: 'مكون نصي بسيط'
                },
                bullets: {
                    name: 'نقاط',
                    description: 'مكون قائمة نقاط'
                },
                logo: {
                    name: 'شعار',
                    description: 'مكون شعار الشركة',
                    missingLogo: 'شعار الشركة مفقود'
                },
                image: {
                    name: 'صورة',
                    description: 'مكون صورة'
                },
                video: {
                    name: 'فيديو',
                    description: 'مكون فيديو'
                },
                shape: {
                    name: 'شكل',
                    description: 'مكون الأشكال الأساسية'
                },
                question: {
                    name: 'سؤال',
                    description: 'مكون سؤال تفاعلي'
                }
            },
            chapterEditor: {
                title: 'محرر الفصول',
                description: 'تحرير محتوى الفصل الخاص بك',
                contentTitle: 'لوحة الرسم',
                canvasDescription: 'اسحب المكونات إلى لوحة الرسم وضعها بحرية',
                emptyState: 'لم تتم إضافة أي مكونات بعد. اسحب المكونات من البنك أو انقر للإضافة.',
                removeComponent: 'إزالة المكون'
            },
            textComponent: {
                placeholder: 'أدخل النص هنا...',
                emptyState: 'انقر لإضافة نص'
            },
            bulletsComponent: {
                placeholder: 'أدخل نص النقطة...',
                emptyState: 'نقطة فارغة',
                removeBullet: 'إزالة نقطة',
                addBullet: 'إضافة نقطة'
            },
            logoComponent: {
                altText: 'شعار الشركة',
                missingLogo: 'شعار الشركة مفقود',
                borderRadius: 'نصف قطر الحدود',
                backgroundColor: 'لون الخلفية',
                opacity: 'الشفافية'
            },
            imageComponent: {
                altText: 'صورة',
                placeholder: 'انقر لإضافة صورة',
                selectorTitle: 'اختر صورة',
                uploadNew: 'رفع جديد',
                imageBank: 'بنك الصور',
                loading: 'جاري التحميل...',
                emptyBank: 'لا توجد صور في البنك',
                cancel: 'إلغاء',
                enterUrl: 'إدخال رابط',
                urlPlaceholder: 'https://example.com/image.jpg',
                submit: 'إرسال',
                changeSource: 'تغيير الصورة'
            },
            backgroundImageComponent: {
                altText: 'صورة الخلفية',
                placeholder: 'انقر لإضافة صورة الخلفية',
                selectorTitle: 'اختر صورة الخلفية',
                uploadNew: 'رفع جديد',
                imageBank: 'بنك الصور',
                loading: 'جاري التحميل...',
                emptyBank: 'لا توجد صور في البنك',
                cancel: 'إلغاء',
                enterUrl: 'إدخال رابط',
                urlPlaceholder: 'https://example.com/image.jpg',
                submit: 'إرسال',
                changeSource: 'تغيير صورة الخلفية'
            },
            videoComponent: {
                altText: 'فيديو',
                placeholder: 'انقر لإضافة فيديو',
                selectorTitle: 'اختر فيديو',
                uploadNew: 'رفع جديد',
                videoBank: 'بنك الفيديو',
                loading: 'جاري التحميل...',
                emptyBank: 'لا توجد فيديوهات في البنك',
                cancel: 'إلغاء',
                enterUrl: 'إدخال رابط',
                urlPlaceholder: 'https://example.com/video.mp4',
                submit: 'إرسال',
                changeSource: 'تغيير الفيديو',
                errorTitle: 'فشل تحميل الفيديو',
                errorMessage: 'لا يمكن تحميل الفيديو. يرجى رفع فيديو جديد أو اختيار آخر من بنك الفيديو.',
                retry: 'إعادة المحاولة',
                selectAnother: 'اختر فيديو آخر',
                edit: 'تحرير'
            },
            shapeComponent: {
                emptyState: 'انقر لاختيار شكل',
                rectangle: 'مستطيل',
                circle: 'دائرة',
                triangle: 'مثلث',
                star: 'نجمة'
            },
            title: {
                label: 'عنوان',
                defaultValue: 'فصل جديد'
            },
            description: {
                label: 'وصف',
                defaultValue: 'وصف الفصل'
            },
            headTitle: {
                label: 'العنوان الرئيسي',
                defaultValue: 'فصل جديد'
            },
            textContent: {
                label: 'محتوى نصي',
                defaultValue: 'أدخل المحتوى الخاص بك هنا'
            },
            bullets: {
                label: 'نقاط',
                remove: 'إزالة',
                add: 'إضافة نقطة',
                addPlaceholder: 'إضافة نقطة جديدة...',
                defaultValue1: 'نقطة 1',
                defaultValue2: 'نقطة 2',
                defaultValue3: 'نقطة 3'
            },
            color: {
                placeholder: '#000000'
            },
            component: {
                borderRadius: 'نصف قطر الحدود',
                backgroundColor: 'لون الخلفية',
                opacity: 'الشفافية',
                textDirection: 'اتجاه النص',
                leftToRight: 'من اليسار إلى اليمين',
                rightToLeft: 'من اليمين إلى اليسار',
                pixelUnit: 'بكسل',
                percentUnit: '%',
                colorValue: (key, { color }) => color,
                backgroundColorValue: (key, { color }) => color,
                borderRadiusAll: 'الكل'
            },
            editorDrawer: {
                title: 'تحرير المكون',
                closeButton: 'إغلاق',
                description: 'تخصيص المكون المحدد',
                typography: 'الطباعة',
                textFormatting: 'تنسيق النص',
                fontSize: 'حجم الخط',
                textColor: 'لون النص',
                shapeType: 'نوع الشكل',
                shapeColor: 'لون الشكل',
                shapeBackground: 'خلفية الشكل',
                colorMode: 'لون',
                gradientMode: 'تدرج',
                gradientColor1: 'اللون الأول',
                gradientColor2: 'اللون الثاني',
                gradientAngle: 'زاوية التدرج',
                borderGradientColor1: 'اللون الأول',
                borderGradientColor2: 'اللون الثاني',
                borderGradientAngle: 'زاوية التدرج',
                shapeOpacity: 'شفافية الشكل',
                borderWidth: 'عرض الحدود',
                borderColor: 'لون الحدود',
                border: 'الحدود',
                style: 'النمط',
                background: 'الخلفية'
            },
            backgroundImage: {
                label: 'صورة الخلفية',
                placeholder: 'أدخل رابط الصورة',
                uploadButton: 'رفع صورة',
                previewAlt: 'معاينة الخلفية',
                invalidImageUrl: 'https://via.placeholder.com/400x200?text=رابط+صورة+غير+صالح'
            },
            logoImage: {
                label: 'الشعار',
                placeholder: 'أدخل رابط الشعار',
                uploadButton: 'رفع الشعار',
                previewAlt: 'معاينة الشعار',
                invalidImageUrl: 'https://via.placeholder.com/400x200?text=رابط+شعار+غير+صالح'
            },
            backgroundImageEditor: {
                title: 'تحرير صورة الخلفية',
                opacity: 'الشفافية',
                backgroundColor: 'لون الخلفية',
                transparent: 'شفاف',
                save: 'حفظ التغييرات',
                remove: 'إزالة صورة الخلفية',
                cancel: 'إلغاء'
            },
            backgroundVideoEditor: {
                title: 'تحرير فيديو الخلفية',
                opacity: 'الشفافية',
                backgroundColor: 'لون الخلفية',
                transparent: 'شفاف',
                save: 'حفظ التغييرات',
                remove: 'إزالة فيديو الخلفية',
                cancel: 'إلغاء'
            },
            backgroundVideoComponent: {
                changeSource: 'تغيير مصدر الفيديو',
                enterUrl: 'أدخل رابط الفيديو',
                urlPlaceholder: 'https://example.com/video.mp4',
                submit: 'تطبيق',
                cancel: 'إلغاء',
                uploadNew: 'رفع فيديو جديد',
                loading: 'جاري التحميل...',
                videoBank: 'بنك الفيديو',
                backgroundVideoBank: 'بنك فيديو الخلفية',
                emptyBank: 'لم يتم العثور على فيديوهات في بنك الفيديو.'
            },
            videoUrl: {
                label: 'رابط الفيديو',
                placeholder: 'أدخل رابط YouTube أو فيديو'
            },
            templateMode: 'وضع القالب',
            courseMode: 'وضع الدورة',
            switchToTemplateMode: 'التبديل إلى وضع القالب',
            switchToCourseMode: 'التبديل إلى وضع الدورة',
            templateDetails: 'إعدادات قالب الدورة',
            templateName: 'اسم القالب',
            templateSubject: 'الفئة / مجال الموضوع',
            templateDescription: 'وصف القالب',
            templateTags: 'العلامات (مفصولة بفواصل)',
            templatePublic: 'متاح للجميع',
            templateReady: 'جاهز للاستخدام',
            saveTemplate: 'حفظ القالب',
            templateValidationError: 'اسم القالب والموضوع مطلوبان',
            templateSaved: 'تم حفظ القالب بنجاح!',
            templateUpdated: 'تم تحديث القالب بنجاح!',
            templateSaveError: 'خطأ في حفظ القالب. يرجى المحاولة مرة أخرى.',
            templateCreateError: 'خطأ في إنشاء قالب جديد. يرجى المحاولة مرة أخرى.',
            fetchError: 'خطأ في تحميل الدورة أو القالب. يرجى المحاولة مرة أخرى.',
            defaultCourseTitle: 'دورة',
            defaultCourseDescription: '',
            templateNamePlaceholder: 'أدخل عنوانًا وصفيًا لهذا القالب',
            templateSubjectPlaceholder: 'مثال: تدريب السلامة، التعريف بالشركة، القيادة',
            templateDescriptionPlaceholder: 'قدم وصفًا مفصلاً لما يغطيه القالب ولمن تم تصميمه',
            templateTagsPlaceholder: 'أضف كلمات مفتاحية لمساعدة المستخدمين في العثور على هذا القالب (مفصولة بفواصل)',
            templateSelectorTitle: 'إنشاء أو اختيار قالب',
            createNewTemplate: 'إنشاء قالب جديد',
            createNewTemplateDesc: 'ابدأ بقالب فارغ وقم ببنائه من الصفر.',
            createTemplate: 'إنشاء قالب',
            selectExistingTemplate: 'اختيار قالب موجود',
            selectExistingTemplateDesc: 'اختر من القوالب الموجودة لديك للتحرير.',
            browseTemplates: 'تصفح القوالب',
            publicAssetBank: 'بنك الأصول العامة',
            publicAssetBankDescription: 'الأصول المضافة هنا ستكون متاحة لجميع القوالب',
            uploadPublicAsset: 'تحميل أصل عام',
            publicAssetUploaded: 'تم تحميل الأصل العام بنجاح!',
            publicAssetUploadError: 'خطأ في تحميل الأصل العام. يرجى المحاولة مرة أخرى.',
            templateAssetName: 'أصل القالب',
            templateAssetDescription: 'تم التحميل من محرر القالب',
            // Template selection
            templateSelectionInstruction: 'اختر قالبًا لفصلك الجديد:',
            featureBadges: {
                video: 'فيديو',
                bullets: 'نقاط',
                textContent: 'محتوى نصي',
                'text-content': 'محتوى نصي',
                heading: 'عنوان'
            }
        },
        templateBank: {
            title: 'اختر قالبًا',
            description: 'اختر قالبًا لفصلك الجديد',
            closeButton: 'إغلاق بنك القوالب',
            selectTemplate: (key, { templateName }) => `اختر قالب ${templateName}`,
            directionSelection: 'اختر اتجاه القالب:',
            ltrDirection: 'اتجاه من اليسار إلى اليمين',
            rtlDirection: 'اتجاه من اليمين إلى اليسار',
            ltrLabel: 'LTR',
            rtlLabel: 'RTL',
            templates: {
                standardSlide: {
                    name: 'شريحة قياسية',
                    description: 'شريحة قياسية مع شعار وعنوان ونص على اليمين وصورة على اليسار'
                },
                videoFocused: {
                    name: 'التركيز على الفيديو',
                    description: 'شريحة مع فيديو كبير في المنتصف ونص داعم أدناه'
                },
                bulletPoints: {
                    name: 'نقاط رئيسية',
                    description: 'شريحة تركز على النقاط الرئيسية للمعلومات المهمة'
                },
                centeredImage: {
                    name: 'صورة مركزية',
                    description: 'شريحة مع صورة كبيرة في المنتصف ونص تعليق أدناه'
                },
                textAndBullets: {
                    name: 'نص ونقاط',
                    description: 'شريحة مع نص على اليسار ونقاط رئيسية على اليمين'
                },
                videoAndBullets: {
                    name: 'فيديو ونقاط',
                    description: 'شريحة مع فيديو على اليسار ونقاط رئيسية على اليمين'
                },
                twoColumnImage: {
                    name: 'صورتان جنبًا إلى جنب',
                    description: 'شريحة مع صورتين جنبًا إلى جنب وتعليق أدناه'
                },
                threeColumnText: {
                    name: 'ثلاثة أعمدة نصية',
                    description: 'شريحة مع ثلاثة أعمدة نصية للمقارنة أو سرد المعلومات ذات الصلة'
                },
                imageGallery: {
                    name: 'معرض الصور',
                    description: 'شريحة مع أربع صور مرتبة في شبكة مع تعليق أدناه'
                },
                videoWithOverlay: {
                    name: 'فيديو مع نص توضيحي',
                    description: 'شريحة مع فيديو ونص توضيحي لإبراز النقاط الرئيسية'
                },
                titleWithBackground: {
                    name: 'عنوان على خلفية صورة',
                    description: 'شريحة مع عنوان ونص على خلفية صورة لتأثير درامي'
                }
            },
            content: {
                slideTitle: 'عنوان الشريحة',
                loremIpsum: 'لوريم إيبسوم دولور سيت أميت، كونسيكتيتور أديبيسينج إليت. نوليم أروس سابيان، بوسيليس كويس، أكوازمان كوازي بمر مودوف.',
                videoTitle: 'عرض فيديو',
                videoDescription: 'يشرح هذا الفيديو المفاهيم الرئيسية للموضوع. شاهده بعناية لفهم الأفكار الرئيسية.',
                bulletTitle: 'النقاط الرئيسية',
                bullet1: 'النقطة الأولى المهمة للتذكر حول هذا الموضوع',
                bullet2: 'المفهوم الرئيسي الثاني الذي يبني على النقطة الأولى',
                bullet3: 'العنصر الأساسي الثالث الذي يكمل الفهم',
                imageTitle: 'تمثيل بصري',
                imageCaption: 'توضح هذه الصورة المفهوم الموصوف في هذا الفصل. ادرسها بعناية لفهم العناصر المرئية.',
                textBulletTitle: 'نظرة عامة على المفهوم',
                textContent: 'يوفر هذا القسم شرحًا مفصلاً للمفهوم. يقدم النص الأفكار الرئيسية ويوفر سياقًا لفهم النقاط الرئيسية المدرجة على اليمين.',
                textBullet1: 'نقطة رئيسية متعلقة بالمفهوم الموضح في النص',
                textBullet2: 'معلومات إضافية تدعم المفهوم الرئيسي',
                textBullet3: 'النقطة النهائية التي تكمل فهم الموضوع',
                videoBulletTitle: 'دليل فيديو مع نقاط رئيسية',
                videoBullet1: 'شاهد الفيديو لفهم العرض التوضيحي',
                videoBullet2: 'اتبع الخطوات الموضحة في الفيديو',
                videoBullet3: 'راجع هذه النقاط أثناء مشاهدة الفيديو',

                // Two-column image template content
                twoColumnImageTitle: 'مقارنة الصور',
                twoColumnImageCaption: 'توضح هذه الصور جوانب مختلفة من المفهوم. قارن بينها لفهم الاختلافات والتشابهات الرئيسية.',

                // Three-column text template content
                threeColumnTitle: 'عملية من ثلاث خطوات',
                column1Text: 'الخطوة 1: ابدأ بفهم المبادئ الأساسية وأسس المفهوم. هذه المرحلة الأولية ضرورية لبناء فهم متين.',
                column2Text: 'الخطوة 2: طبق المبادئ في سيناريوهات عملية واستكشف كيفية تفاعلها مع المواقف الواقعية. الممارسة ضرورية لإتقان المهارة.',
                column3Text: 'الخطوة 3: قيّم فهمك وحسّن نهجك بناءً على التعليقات والنتائج. التحسين المستمر يؤدي إلى الخبرة.',

                // Image gallery template content
                imageGalleryTitle: 'معرض الأمثلة المرئية',
                imageGalleryCaption: 'تعرض هذه المجموعة من الصور جوانب مختلفة من الموضوع. كل صورة تمثل مثالاً أو تطبيقاً مختلفاً.',

                // Video with overlay template content
                videoOverlayTitle: 'فيديو مع إبراز النقاط الرئيسية',
                videoOverlayText: 'هام: انتبه بشكل خاص لهذا العرض التوضيحي حيث يعرض تقنيات حاسمة.',

                // Title with background template content
                backgroundTitle: 'نظرة عامة على الفصل',
                backgroundSubtitle: 'المفاهيم والمبادئ الأساسية',
                backgroundText: 'يقدم هذا الفصل المفاهيم الأساسية التي تشكل أساس الموضوع. فهم هذه المبادئ أمر بالغ الأهمية لإتقان المواضيع الأكثر تقدماً التي تليها.'
            }
        },
        courseTemplateBank: {
            title: 'إنشاء دورة باستخدام الذكاء الاصطناعي',
            description: 'اختر قالب دورة لإنشاء دورة جديدة بمحتوى تم إنشاؤه بواسطة الذكاء الاصطناعي',
            courseTemplatesTitle: 'قوالب الدورة',
            chapterTemplatesTitle: (key, { count }) => `الشرائح المضمنة (${count})`,
            slideCount: (key, { count }) => `${count} شريحة`,
            defaultCourseTitle: 'دورة جديدة',
            defaultCourseDescription: 'دورة تم إنشاؤها باستخدام الذكاء الاصطناعي',
            defaultSectionTitle: 'القسم 1',
            cancelButton: 'إلغاء',
            createButton: 'إنشاء دورة',
            yourDescription: 'وصف الدورة الخاص بك:',
            defaultTemplatesTab: 'القوالب الافتراضية',
            designedTemplatesTab: 'القوالب المصممة',
            loadingTemplates: 'جاري تحميل القوالب...',
            noDesignedTemplates: 'لا توجد قوالب مصممة متاحة حاليًا.',
            estimatedDuration: (key, { duration }) => `${duration} دقيقة`,
            noDescription: 'لا يوجد وصف متاح',
            noPreviewAvailable: 'لا توجد معاينة متاحة',
            generationStartError: 'حدث خطأ أثناء بدء إنشاء الدورة. يرجى المحاولة مرة أخرى.',
            courseTypes: {
                business: 'أعمال',
                technical: 'تقني',
                educational: 'تعليمي',
                onboarding: 'تأهيل الموظفين',
                compliance: 'امتثال',
                product: 'منتج'
            },
            templates: {
                businessCourse: {
                    name: 'دورة أعمال',
                    description: 'قالب دورة أعمال شامل مع شرائح تغطي مفاهيم الأعمال الرئيسية والاستراتيجيات ودراسات الحالة'
                },
                technicalCourse: {
                    name: 'دورة تقنية',
                    description: 'قالب دورة تقنية مفصل مع شرائح تغطي المفاهيم التقنية والعروض التوضيحية والأمثلة العملية'
                },
                educationalCourse: {
                    name: 'دورة تعليمية',
                    description: 'قالب دورة تعليمية منظم مع شرائح مصممة للتعلم الفعال والاحتفاظ بالمعرفة'
                },
                onboardingCourse: {
                    name: 'دورة تأهيل الموظفين',
                    description: 'قالب دورة تأهيل الموظفين مع شرائح لتقديم الموظفين الجدد إلى سياسات الشركة وإجراءاتها وثقافتها'
                },
                complianceCourse: {
                    name: 'دورة امتثال',
                    description: 'قالب دورة امتثال مع شرائح تغطي المتطلبات التنظيمية وأفضل الممارسات وإجراءات الامتثال'
                },
                productCourse: {
                    name: 'دورة منتج',
                    description: 'قالب دورة تدريب على المنتج مع شرائح تعرض ميزات المنتج وفوائده وأمثلة الاستخدام'
                }
            }
        }
    },
    AIGeneration: {
        titles: {
            WEEZBEE_COURSE: 'إنشاء دورة باستخدام الذكاء الاصطناعي',
            EXAM: 'إنشاء امتحان باستخدام الذكاء الاصطناعي',
            SURVEY: 'إنشاء استطلاع باستخدام الذكاء الاصطناعي',
            default: 'إنشاء محتوى باستخدام الذكاء الاصطناعي',
        },
        buttonText: {
            WEEZBEE_COURSE: 'إنشاء دورة باستخدام AI',
            EXAM: 'إنشاء أسئلة باستخدام AI',
            SURVEY: 'إنشاء أسئلة باستخدام AI',
            default: 'إنشاء باستخدام AI',
        }
    },
    videoPlayer: {
        pleaseEnterVideoUrl: 'الرجاء إدخال رابط الفيديو',
    },
    imageBank: {
        title: 'بنك صور الشركة',
        noImages: 'لم يتم العثور على صور في بنك صور الشركة.',
        clickToCopy: 'انقر لنسخ الرابط',
        urlCopied: 'تم نسخ رابط الصورة إلى الحافظة!',
        copyFailed: 'فشل نسخ الرابط. يرجى المحاولة يدويًا.',
        fetchError: 'فشل تحميل الصور. يرجى المحاولة مرة أخرى لاحقًا.',
        featureFlagDisabled: 'ميزة بنك الصور غير مفعلة لشركتك.'
    },
    course: {
        untitled: 'دورة بدون عنوان',
        notFound: 'لم يتم العثور على الدورة. يرجى التحقق من الرابط أو الاتصال بالدعم.',
        fetchError: 'فشل تحميل الدورة. يرجى المحاولة مرة أخرى لاحقًا.',
        loading: 'جاري تحميل الدورة...',
        error: 'خطأ في تحميل الدورة',
        error: {
            sessionDateRequired: 'يرجى تعيين تاريخ ووقت الدورة قبل التخصيص للمؤسسات'
        }
    },
    assetBank: {
        title: 'بنك أصول الشركة',
        publicTitle: 'بنك الأصول العام',
        noImages: 'لم يتم العثور على صور في بنك أصول الشركة.',
        noVideos: 'لم يتم العثور على فيديوهات في بنك أصول الشركة.',
        clickToCopy: 'انقر لنسخ الرابط',
        urlCopied: 'تم نسخ الرابط إلى الحافظة!',
        copyFailed: 'فشل نسخ الرابط. يرجى المحاولة يدويًا.',
        fetchImageError: 'فشل تحميل الصور. يرجى المحاولة مرة أخرى لاحقًا.',
        fetchVideoError: 'فشل تحميل الفيديوهات. يرجى المحاولة مرة أخرى لاحقًا.',
        imagesTab: 'الصور',
        videosTab: 'الفيديوهات',
        featureFlagDisabled: 'ميزة بنك الأصول غير مفعلة لشركتك.',
        addToChapterTooltip: 'إضافة إلى الفصل',
        addToChapter: 'إضافة إلى الفصل',
        addAsBackgroundTooltip: 'إضافة كخلفية للفصل',
        addAsBackground: 'إضافة كخلفية',
        addedToChapter: (key, { type }) => `تمت إضافة ${type === 'image' ? 'الصورة' : 'الفيديو'} إلى الفصل!`,
        addedAsBackground: 'تمت إضافة الصورة كخلفية للفصل!',
        addedAsBackgroundVideo: 'تمت إضافة الفيديو كخلفية للفصل!',
        uploadImage: 'تحميل صورة',
        uploadVideo: 'تحميل فيديو',
        uploadSuccess: 'تم تحميل الملف بنجاح',
        uploadError: 'خطأ في تحميل الملف',
        invalidFileType: 'نوع ملف غير صالح',
        fileTooLarge: (key, { maxSize }) => `الملف كبير جدًا. الحجم الأقصى هو ${maxSize}`
    },
    courseAttendance: {
        title: 'حضور الدورة',
        description: 'حدد الحضور أو عدم الحضور للمستخدمين المسجلين في الدورات',
        searchPlaceholder: 'البحث باسم المستخدم أو الدورة...',
        noData: 'لا توجد دورات تنتظر تحديد الحضور',
        columns: {
            userName: 'اسم المستخدم',
            phone: 'الهاتف',
            idNumber: 'رقم الهوية',
            courseName: 'اسم الدورة',
            courseType: 'نوع الدورة',
            sessionDate: 'تاريخ الجلسة',
            actions: 'الإجراءات'
        },
        courseTypes: {
            frontal: 'أمامي',
            online: 'عبر الإنترنت'
        },
        actions: {
            markAttended: 'تحديد كحاضر',
            markNoShow: 'تحديد كغائب'
        },
        tooltips: {
            sessionNotToday: 'يمكن تحديد الحضور فقط في يوم الجلسة'
        },
        errors: {
            markAttendedFailed: 'خطأ في تحديد الحضور. يرجى المحاولة مرة أخرى.',
            markNoShowFailed: 'خطأ في تحديد عدم الحضور. يرجى المحاولة مرة أخرى.'
        },
        filters: {
            allCourses: 'جميع الدورات'
        }
    },
    courseFields: {
        sessionStartDate: 'تاريخ ووقت البدء',
        sessionDuration: 'مدة الدرس (بالدقائق)',
        location: 'الموقع (العنوان/الغرفة)',
        meetingLink: 'رابط الاجتماع (Zoom/Google Meet)',
        instructor: 'اسم المدرب',
        onlineSession: 'جلسة عبر الإنترنت',
        invalidMeetingLink: 'يرجى إدخال رابط اجتماع صحيح من منصة معترف بها (Zoom، Microsoft Teams، Google Meet، Webex، GoToMeeting، Jitsi، Whereby، إلخ)',
    },
    certifications: {
        category: 'الفئة',
        categoryForceCompletion: 'مهمة مطلوبة',
        categoryCertification: 'شهادة',
        categoryKnowledgeCenter: 'مركز المعرفة',
        categoryChangeDisabled: {
            multipleVersions: 'لا يمكن تغيير الفئة عند وجود إصدارات متعددة'
        },
        expiryDuration: {
            toggleLabel: 'إضافة صلاحية للشهادة',
            title: 'صلاحية الشهادة',
            valueLabel: 'المدة',
            unitLabel: 'وحدة الوقت',
            units: {
                years: 'سنوات',
                months: 'أشهر',
                days: 'أيام'
            },
            note: 'حدد فترة صلاحية الشهادة. سيحسب النظام تاريخ انتهاء الصلاحية من تاريخ إكمال الشهادة.'
        },
    },
    durationPicker: {
        label: 'المدة حتى الإكمال',
        valueLabel: 'الكمية',
        valuePlaceholder: 'أدخل القيمة',
        unitPlaceholder: 'اختر الوحدة',
        days: 'أيام',
        months: 'أشهر',
        years: 'سنوات',
        MINUTES: 'دقائق',
        DAYS: 'أيام',
        MONTHS: 'أشهر',
        YEARS: 'سنوات',
        errorInvalidValue: 'الرجاء إدخال رقم موجب'
    },
    selectDurationModal: {
        titleOrg: 'تحديد المدة للوحدة التنظيمية',
        titleUser: 'تحديد المدة للمستخدم',
        durationLabel: 'الوقت لإكمال المهمة',
        explanation: 'سيتلقى المستخدمون موعدًا نهائيًا محسوبًا من تاريخ التعيين الخاص بهم. على سبيل المثال، إذا قمت بتعيين 60 يومًا، فسيحصل المستخدم المعين اليوم على 60 يومًا لإكمال المهمة.'
    },
    userProgressReport: {
        exportToExcel: 'تصدير إلى Excel',
        exporting: 'جاري التصدير...',
        exportCurrentFilters: 'تصدير الفلاتر الحالية'
    },
    learningManagement: {
        createEditNewSignDocModal: {
            approversSection: {
                title: 'اختر المعتمدين (اختياري)',
                description: 'اختر مستخدمين محددين يمكنهم الموافقة على التحميلات. إذا لم يتم الاختيار، فسيكون جميع مسؤولي الوحدات التنظيمية المعينة معتمدين.',
                userLabel: 'اختر مستخدمين محددين كمعتمدين',
                defaultInfo: 'إذا لم يتم اختيار مستخدمين محددين، فسيتمكن أنت أو مسؤولو الشركة فقط من الموافقة على التحميلات'
            },
            individualUsersSection: {
                title: 'تعيين لمستخدمين فرديين',
                userLabel: 'البحث عن مستخدمين للتعيين الفردي',
                searchLabel: 'البحث عن المستخدمين',
                searchPlaceholder: 'اكتب الاسم أو الهاتف أو البريد الإلكتروني...',
                noUsersFound: 'لم يتم العثور على مستخدمين يطابقون بحثك',
            },
            // Organization search
            organizationsSection: {
                searchLabel: 'البحث عن منظمة',
                searchPlaceholder: 'اكتب اسم المنظمة...',
            },
            // User pagination labels
            noUsers: 'لم يتم العثور على مستخدمين',
            selectedLabel: 'تم اختيار مستخدمين',
            noOrganizations: 'لم يتم العثور على منظمات',
            selectedOrgsLabel: 'تم اختيار منظمات',
            userPaginationError: 'خطأ في تحميل المستخدمين',
            userPaginationErrorMessage: 'تعذر تحميل قائمة المستخدمين. يرجى المحاولة مرة أخرى باستخدام أسهم التنقل.',
            orgPaginationError: 'خطأ في تحميل المنظمات',
            orgPaginationErrorMessage: 'تعذر تحميل قائمة المنظمات. يرجى المحاولة مرة أخرى باستخدام أسهم التنقل.',
            uploadError: 'فشل رفع الملف',
            uploadErrorMessage: 'فشل الرفع. يرجى المحاولة مرة أخرى.'
        }
    },
    addToHomeScreen: {
        title: 'قم بتثبيت التطبيق',
        description: 'قم بتثبيت WeezBee على جهازك للوصول السريع وتجربة أفضل.',
        install: 'تثبيت الآن',
        dismiss: 'حسنًا، شكرًا!',
        neverAskAgain: 'لا تعرض مرة أخرى',
        benefits: {
            faster: 'وصول أسرع',
            offline: 'يعمل دون اتصال',
            homeScreen: 'اختصار على الشاشة الرئيسية'
        },
        iosInstructions: {
            title: 'لتثبيت التطبيق على iPhone الخاص بك:',
            step1Part1: 'اضغط على زر "مشاركة"',
            step1Part2: '- موجود في شريط العنوان أو القائمة',
            step2: 'مرر لأسفل في القائمة التي تفتح',
            step3: 'اضغط على "إضافة إلى الشاشة الرئيسية"',
            step4: 'اضغط على "إضافة" في الزاوية العلوية للإنهاء'
        }
    },
    learningPath: {
        sequentialOnlyDisclaimer: 'مسار التعلم هذا معرّف كـ"متكرر" - يمكن إضافة مهام متكررة فقط',
        freePath: {
            checkboxLabel: 'مسار حر — اختر المهام بأي ترتيب',
            checkboxHelper: 'عند التفعيل، يمكن للمستخدمين المعينين البدء بأي مهمة فوراً وإتمامها بأي ترتيب يختارونه. عند التعطيل، يجب إتمام المهام بالتسلسل.',
            adminBanner: 'وضع المسار الحر مفعّل. يمكن للمستخدمين المعينين إتمام المهام بأي ترتيب.',
            confirmSwitchToOrderedTitle: 'التبديل إلى ترتيب المهام التسلسلي؟',
            confirmSwitchToOrderedBody: 'مسار التعلم هذا محدد حالياً كمسار حر وقد تم تعيينه للمستخدمين. التبديل إلى الترتيب التسلسلي يعني أن المستخدمين المعينين سيُلزَمون بإتمام المهام وفق الترتيب المحدد. المستخدمون الذين أتموا مهاماً بترتيب مختلف سيحتفظون بتقدمهم، لكن المهمة التالية المتاحة ستكون أول مهمة غير مكتملة في التسلسل — مما قد يبدو غير متوقع. هل تريد المتابعة؟',
            confirmSwitchToOrderedConfirm: 'التبديل إلى الترتيب التسلسلي',
            badge: 'مسار حر',
        },
    },
};
